/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  TimeSignalAttributeValue: any;
  UnqualifiedDateTime: any;
};

export type AnalyticsByDay = {
  __typename?: 'AnalyticsByDay';
  date: Scalars['String'];
  totalCount: Scalars['Int'];
  totalDuration: Scalars['Int'];
};

export type AnalyticsDateRangeFilter = {
  fromDate: Scalars['Date'];
  toDate: Scalars['Date'];
};

export type AnalyticsMetaData = {
  __typename?: 'AnalyticsMetaData';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AnalyticsMetaDataValue = {
  __typename?: 'AnalyticsMetaDataValue';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AnalyticsMetaDataValueInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AnalyticsMetadataInput = {
  type: AnalyticsMetadataType;
};

export type AnalyticsMetadataResult = {
  __typename?: 'AnalyticsMetadataResult';
  metadata?: Maybe<Array<AnalyticsMetaDataValue>>;
};

export enum AnalyticsMetadataType {
  MetadataOefList = 'METADATA_OEF_LIST'
}

export type AppendInstallErrorInput = {
  collectorId: Scalars['String'];
  date?: Maybe<Scalars['DateTime']>;
  installId: Scalars['String'];
  message: Scalars['String'];
  tenantSlug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AppendInstallErrorResult = {
  __typename?: 'AppendInstallErrorResult';
  collectorId: Scalars['String'];
  errorId: Scalars['String'];
};

export type Collector = {
  __typename?: 'Collector';
  appScope?: Maybe<Array<Maybe<Scalars['String']>>>;
  category: Scalars['String'];
  configURL?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  diagnosticsURL?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image: CollectorLogo;
  installURL?: Maybe<Scalars['String']>;
  installations?: Maybe<CollectorInstallations>;
  name: Scalars['String'];
  publishedBy: Scalars['String'];
  retryURL?: Maybe<Scalars['String']>;
  type: CollectorType;
  uninstallURL?: Maybe<Scalars['String']>;
  userInstallURL?: Maybe<Scalars['String']>;
  userUninstallURL?: Maybe<Scalars['String']>;
};

export type CollectorGroupSettings = {
  __typename?: 'CollectorGroupSettings';
  accessScopeIn?: Maybe<GroupAccessScopes>;
  canOptOut: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
};

export type CollectorGroupSettingsInput = {
  accessScopeIn?: Maybe<GroupAccessScopesInput>;
  canOptOut: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
};

export type CollectorInput = {
  scope: CollectorScope;
  searchText?: Maybe<Scalars['String']>;
};

export type CollectorInstallError = {
  __typename?: 'CollectorInstallError';
  date: Scalars['DateTime'];
  errorId: Scalars['String'];
  message: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type CollectorInstallStatus = {
  __typename?: 'CollectorInstallStatus';
  errors?: Maybe<Array<Maybe<CollectorInstallError>>>;
  isAuthorized?: Maybe<Scalars['Boolean']>;
};

export type CollectorInstallation = {
  __typename?: 'CollectorInstallation';
  installId: Scalars['String'];
  scope: CollectorSettingScope;
};

export type CollectorInstallations = {
  __typename?: 'CollectorInstallations';
  items?: Maybe<Array<Maybe<CollectorInstallation>>>;
};

export type CollectorLogo = {
  __typename?: 'CollectorLogo';
  src: Scalars['String'];
};

export type CollectorResult = {
  __typename?: 'CollectorResult';
  item?: Maybe<Collector>;
};

export enum CollectorScope {
  All = 'ALL',
  Tenant = 'TENANT',
  User = 'USER'
}

export type CollectorSetting = {
  __typename?: 'CollectorSetting';
  canOptOut?: Maybe<Scalars['Boolean']>;
  collectorId: Scalars['String'];
  collectorMetadata?: Maybe<Collector>;
  groupSettings?: Maybe<Array<CollectorGroupSettings>>;
  installId: Scalars['String'];
  installStatus?: Maybe<CollectorInstallStatus>;
  installedDate: Scalars['DateTime'];
  maintainers: Array<Maintainer>;
  scope: CollectorSettingScope;
  settings: Array<Setting>;
  userPreferences: Array<Setting>;
};

export type CollectorSettingInput = {
  filterByCollectorId?: Maybe<FilterByCollectorIdInput>;
  installId?: Maybe<Scalars['String']>;
};

export type CollectorSettingResult = {
  __typename?: 'CollectorSettingResult';
  item?: Maybe<CollectorSetting>;
};

export enum CollectorSettingScope {
  Tenant = 'TENANT',
  User = 'USER'
}

export type CollectorSettingUserPreference = {
  __typename?: 'CollectorSettingUserPreference';
  userId: Scalars['String'];
  userPreferences: Array<Setting>;
};

export type CollectorSettingUserPreferencesInput = {
  collectorId: Scalars['String'];
  cursor?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type CollectorSettingUserPreferencesResult = {
  __typename?: 'CollectorSettingUserPreferencesResult';
  collectorId: Scalars['String'];
  cursor?: Maybe<Scalars['String']>;
  installId?: Maybe<Scalars['String']>;
  settings: Array<Maybe<Setting>>;
  userPreferences: Array<Maybe<CollectorSettingUserPreference>>;
};

export type CollectorSettingsInput = {
  cursor?: Maybe<Scalars['String']>;
  filterByScope?: Maybe<CollectorSettingScope>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type CollectorSettingsResult = {
  __typename?: 'CollectorSettingsResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<Maybe<CollectorSetting>>;
};

export enum CollectorType {
  Bot = 'BOT',
  Cloud = 'CLOUD',
  Desktop = 'DESKTOP',
  Plugin = 'PLUGIN'
}

export type CollectorsResult = {
  __typename?: 'CollectorsResult';
  items: Array<Collector>;
};

export type ConfirmCollectorInstallV2Input = {
  tag: Scalars['String'];
};

export type ConfirmCollectorInstallV2Result = {
  __typename?: 'ConfirmCollectorInstallV2Result';
  collectorId: Scalars['String'];
  installId: Scalars['String'];
  tag: Scalars['String'];
};

export type ConfirmUserCollectorInstallV2Input = {
  tag: Scalars['String'];
};

export type ConfirmUserCollectorInstallV2Result = {
  __typename?: 'ConfirmUserCollectorInstallV2Result';
  collectorId: Scalars['String'];
  installId: Scalars['String'];
  tag: Scalars['String'];
};

export type CreateCustomLabelInput = {
  name: Scalars['String'];
  type: LabelType;
};

export type CreateCustomLabelOptionsInput = {
  options: Array<CustomLabelOptionsInput>;
};

export type CreateCustomLabelOptionsResult = {
  __typename?: 'CreateCustomLabelOptionsResult';
  customLabelOptions: Array<SelectLabelOption>;
};

export type CreateCustomLabelResult = {
  __typename?: 'CreateCustomLabelResult';
  customLabel: Label;
};

export type CreateTimeSignalInput = {
  acceptedBy?: Maybe<TimeSignalAcceptedBy>;
  attributes?: Maybe<Array<Maybe<TimeSignalAttributeInput>>>;
  classification?: Maybe<TimeSignalClassification>;
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  excluded?: Maybe<Scalars['Boolean']>;
  labelValues?: Maybe<Array<LabelValueDetailsInput>>;
  labelValuesInferenceId?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  sources?: Maybe<Array<TimeSignalSourcesInput>>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type CreateTimeSignalResult = {
  __typename?: 'CreateTimeSignalResult';
  timeSignal: TimeSignal;
};

export type CustomLabelOptionsInput = {
  customLabelId: Scalars['String'];
  name: Scalars['String'];
};

export type CustomTerm = {
  __typename?: 'CustomTerm';
  customTerm: Scalars['String'];
  originalTerm: Scalars['String'];
};

export type DataSciencePerformanceAnalyticsResult = {
  __typename?: 'DataSciencePerformanceAnalyticsResult';
  overallAccuracy?: Maybe<Scalars['Float']>;
};

export type DateRangeInput = {
  fromDate: Scalars['Date'];
  toDate: Scalars['Date'];
};

export type DateTimeFormat = {
  __typename?: 'DateTimeFormat';
  dotNetPattern: Scalars['String'];
  luxonPattern: Scalars['String'];
};

export type DateTimeSetting = {
  __typename?: 'DateTimeSetting';
  fullDateTimeFormat: DateTimeFormat;
  longDateFormat: DateTimeFormat;
  longTimeFormat: DateTimeFormat;
  shortDateFormat: DateTimeFormat;
  shortTimeFormat: DateTimeFormat;
};

export type DefaultBillingRateInput = {
  projectUri: Scalars['String'];
  taskUri?: Maybe<Scalars['String']>;
};

export type DefaultBillingRateResult = {
  __typename?: 'DefaultBillingRateResult';
  item?: Maybe<TimesheetLabelValue>;
};

export type DefaultLabelValue = {
  __typename?: 'DefaultLabelValue';
  idValue?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  stringValue?: Maybe<Scalars['String']>;
};

export type DeleteCustomLabelInput = {
  id: Scalars['String'];
};

export type DeleteCustomLabelOptionsInput = {
  ids: Array<Scalars['String']>;
};

export type DeleteCustomLabelOptionsResult = {
  __typename?: 'DeleteCustomLabelOptionsResult';
  ids: Array<Scalars['String']>;
};

export type DeleteCustomLabelResult = {
  __typename?: 'DeleteCustomLabelResult';
  id: Scalars['String'];
};

export type DeleteTimeSignalInput = {
  id: Scalars['String'];
};

export type DeleteTimeSignalResult = {
  __typename?: 'DeleteTimeSignalResult';
  id: Scalars['String'];
};

export type DeleteTimeSignalsInput = {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  selectionFilter: TimeSignalFilterInput;
};

export type DeleteTimeSignalsResult = {
  __typename?: 'DeleteTimeSignalsResult';
  cursor?: Maybe<Scalars['String']>;
  ids: Array<Scalars['String']>;
};

export type DiariesForDateRangeResult = {
  __typename?: 'DiariesForDateRangeResult';
  diaries: Array<Diary>;
};

export type Diary = {
  __typename?: 'Diary';
  date: Scalars['Date'];
  entries: Array<DiaryEntry>;
  lastSyncTime?: Maybe<Scalars['DateTime']>;
  taskNameFormat: DiaryTaskNameFormat;
};

export type DiaryEntry = {
  __typename?: 'DiaryEntry';
  canBeSynced: Scalars['Boolean'];
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  errors: Array<DiaryError>;
  id: Scalars['String'];
  labelValues: Array<DiaryLabelValue>;
  lastSyncTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  syncStatus: DiaryEntrySyncStatus;
  timeSignals: Array<TimeSignal>;
};

export enum DiaryEntrySyncStatus {
  DeletePending = 'DELETE_PENDING',
  NotSynced = 'NOT_SYNCED',
  Synced = 'SYNCED',
  UpdatePending = 'UPDATE_PENDING'
}

export type DiaryError = {
  __typename?: 'DiaryError';
  code?: Maybe<DiaryErrorCode>;
  description: Scalars['String'];
  isCritical?: Maybe<Scalars['Boolean']>;
};

export enum DiaryErrorCode {
  ReadonlyTimesheet = 'READONLY_TIMESHEET',
  ReadonlyTimeEntry = 'READONLY_TIME_ENTRY'
}

export type DiaryLabelValue = {
  __typename?: 'DiaryLabelValue';
  error?: Maybe<DiaryError>;
  label: Label;
  value?: Maybe<LabelValue>;
};

export enum DiaryTaskNameFormat {
  BoldClientBreakProjectTask = 'BOLD_CLIENT_BREAK_PROJECT_TASK',
  BoldProgramBreakProjectTask = 'BOLD_PROGRAM_BREAK_PROJECT_TASK',
  BoldProjectBreakTask = 'BOLD_PROJECT_BREAK_TASK',
  BoldProjectTask = 'BOLD_PROJECT_TASK',
  BoldTaskBreakClientProject = 'BOLD_TASK_BREAK_CLIENT_PROJECT',
  BoldTaskBreakProgramProject = 'BOLD_TASK_BREAK_PROGRAM_PROJECT',
  BoldTaskBreakProject = 'BOLD_TASK_BREAK_PROJECT',
  ClientBreakBoldProjectTask = 'CLIENT_BREAK_BOLD_PROJECT_TASK',
  ClientProjectBoldTask = 'CLIENT_PROJECT_BOLD_TASK',
  ClientProjectBreakBoldTask = 'CLIENT_PROJECT_BREAK_BOLD_TASK',
  ProgramBreakBoldProjectTask = 'PROGRAM_BREAK_BOLD_PROJECT_TASK',
  ProgramProjectBoldTask = 'PROGRAM_PROJECT_BOLD_TASK',
  ProgramProjectBreakBoldTask = 'PROGRAM_PROJECT_BREAK_BOLD_TASK',
  ProjectBoldTask = 'PROJECT_BOLD_TASK',
  ProjectBreakBoldTask = 'PROJECT_BREAK_BOLD_TASK',
  ProjectTask = 'PROJECT_TASK'
}

export type DisableInstallErrorInput = {
  collectorId: Scalars['String'];
  errorId: Scalars['String'];
  tenantSlug?: Maybe<Scalars['String']>;
};

export type DisableInstallErrorResult = {
  __typename?: 'DisableInstallErrorResult';
  collectorId: Scalars['String'];
  errorId: Scalars['String'];
};

export type DisconnectUserCollectorInput = {
  collectorId: Scalars['String'];
};

export type DisconnectUserCollectorResult = {
  __typename?: 'DisconnectUserCollectorResult';
  status?: Maybe<Scalars['Int']>;
};

export type Duration = {
  __typename?: 'Duration';
  days: Scalars['Int'];
  hours: Scalars['Int'];
  milliseconds: Scalars['Int'];
  minutes: Scalars['Int'];
  seconds: Scalars['Int'];
};

export type EnabledGroupTypesResult = {
  __typename?: 'EnabledGroupTypesResult';
  items?: Maybe<Array<GroupTypeDetails>>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  boolean: Scalars['Boolean'];
  numeric: Scalars['Float'];
  string: Scalars['String'];
};


export type FeatureFlagsBooleanArgs = {
  default: Scalars['Boolean'];
  name: Scalars['String'];
};


export type FeatureFlagsNumericArgs = {
  default: Scalars['Float'];
  name: Scalars['String'];
};


export type FeatureFlagsStringArgs = {
  default: Scalars['String'];
  name: Scalars['String'];
};

export type FilterByCollectorIdInput = {
  collectorId?: Maybe<Scalars['String']>;
  scope: CollectorSettingScope;
};

export type GetAutoAcceptSettingResult = {
  __typename?: 'GetAutoAcceptSettingResult';
  enabled: Scalars['Boolean'];
};

export type GetSmartSuggestionSettingResult = {
  __typename?: 'GetSmartSuggestionSettingResult';
  settings?: Maybe<Array<SmartSuggestionSettings>>;
};

export type GetStartEndSettingResult = {
  __typename?: 'GetStartEndSettingResult';
  settings?: Maybe<Array<StartEndSettings>>;
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GroupAccessScope = {
  __typename?: 'GroupAccessScope';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type GroupAccessScopeInput = {
  costCenters?: Maybe<Array<GroupAccessScopeValue>>;
  departmentGroups?: Maybe<Array<GroupAccessScopeValue>>;
  divisions?: Maybe<Array<GroupAccessScopeValue>>;
  employeeTypeGroups?: Maybe<Array<GroupAccessScopeValue>>;
  locations?: Maybe<Array<GroupAccessScopeValue>>;
  serviceCenters?: Maybe<Array<GroupAccessScopeValue>>;
};

export type GroupAccessScopeResult = {
  __typename?: 'GroupAccessScopeResult';
  costCenters?: Maybe<Array<GroupAccessScope>>;
  departmentGroups?: Maybe<Array<GroupAccessScope>>;
  divisions?: Maybe<Array<GroupAccessScope>>;
  employeeTypeGroups?: Maybe<Array<GroupAccessScope>>;
  locations?: Maybe<Array<GroupAccessScope>>;
  serviceCenters?: Maybe<Array<GroupAccessScope>>;
};

export type GroupAccessScopeValue = {
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type GroupAccessScopes = {
  __typename?: 'GroupAccessScopes';
  costCenters?: Maybe<Array<Group>>;
  departments?: Maybe<Array<Group>>;
  divisions?: Maybe<Array<Group>>;
  employeeTypes?: Maybe<Array<Group>>;
  locations?: Maybe<Array<Group>>;
  serviceCenters?: Maybe<Array<Group>>;
};

export type GroupAccessScopesInput = {
  costCenters?: Maybe<Array<GroupInput>>;
  departments?: Maybe<Array<GroupInput>>;
  divisions?: Maybe<Array<GroupInput>>;
  employeeTypes?: Maybe<Array<GroupInput>>;
  locations?: Maybe<Array<GroupInput>>;
  serviceCenters?: Maybe<Array<GroupInput>>;
};

export type GroupInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GroupSearchInput = {
  count?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
};

export type GroupSearchResult = {
  __typename?: 'GroupSearchResult';
  displayText: Scalars['String'];
  id: Scalars['String'];
  level: Scalars['Int'];
};

export type GroupSearchResults = {
  __typename?: 'GroupSearchResults';
  items: Array<GroupSearchResult>;
};

export enum GroupType {
  CostCenter = 'COST_CENTER',
  Department = 'DEPARTMENT',
  Division = 'DIVISION',
  EmployeeType = 'EMPLOYEE_TYPE',
  Location = 'LOCATION',
  ServiceCenter = 'SERVICE_CENTER'
}

export type GroupTypeDetails = {
  __typename?: 'GroupTypeDetails';
  value: GroupType;
};

export type GroupsSearch = {
  __typename?: 'GroupsSearch';
  costCenters: GroupSearchResults;
  departments: GroupSearchResults;
  divisions: GroupSearchResults;
  employeeTypes: GroupSearchResults;
  locations: GroupSearchResults;
  serviceCenters: GroupSearchResults;
};


export type GroupsSearchCostCentersArgs = {
  input?: Maybe<GroupSearchInput>;
};


export type GroupsSearchDepartmentsArgs = {
  input?: Maybe<GroupSearchInput>;
};


export type GroupsSearchDivisionsArgs = {
  input?: Maybe<GroupSearchInput>;
};


export type GroupsSearchEmployeeTypesArgs = {
  input?: Maybe<GroupSearchInput>;
};


export type GroupsSearchLocationsArgs = {
  input?: Maybe<GroupSearchInput>;
};


export type GroupsSearchServiceCentersArgs = {
  input?: Maybe<GroupSearchInput>;
};

export type InstallCollectorResult = {
  __typename?: 'InstallCollectorResult';
  collectorId: Scalars['String'];
  installId: Scalars['String'];
};

export type InstallCollectorV2Input = {
  collectorId: Scalars['String'];
  installId: Scalars['String'];
};

export type InstallCollectorV2Result = {
  __typename?: 'InstallCollectorV2Result';
  installId: Scalars['String'];
};

export type InstallUserCollectorResult = {
  __typename?: 'InstallUserCollectorResult';
  collectorId: Scalars['String'];
  installId: Scalars['String'];
};

export type InstallUserCollectorV2Input = {
  collectorId: Scalars['String'];
  installId: Scalars['String'];
};

export type InstallUserCollectorV2Result = {
  __typename?: 'InstallUserCollectorV2Result';
  installId: Scalars['String'];
};

export type Label = {
  __typename?: 'Label';
  defaultValue?: Maybe<DefaultLabelValue>;
  id: Scalars['String'];
  name: Scalars['String'];
  origin?: Maybe<LabelOrigin>;
  selectOptions?: Maybe<SelectOptionsResult>;
  type: LabelType;
};


export type LabelDefaultValueArgs = {
  date: Scalars['Date'];
};


export type LabelSelectOptionsArgs = {
  input?: Maybe<SelectOptionsInput>;
};

export enum LabelOrigin {
  Timesheet = 'TIMESHEET',
  User = 'USER'
}

export type LabelSuggestionDetails = {
  __typename?: 'LabelSuggestionDetails';
  label: Label;
  suggestedValues: Array<Maybe<SuggestionLabelValue>>;
  suggestionMetadata?: Maybe<Scalars['String']>;
};

export type LabelSuggestionsInput = {
  attributes?: Maybe<Array<SuggestionAttributesInput>>;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  inferenceId?: Maybe<Scalars['String']>;
  labelValues: Array<SuggestionLabelValueDetailsInput>;
  sources?: Maybe<Array<TimeSignalSourceInput>>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type LabelSuggestionsResult = {
  __typename?: 'LabelSuggestionsResult';
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['UnqualifiedDateTime']>;
  inferenceId?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['UnqualifiedDateTime']>;
  suggestions: Array<LabelSuggestionDetails>;
};

export enum LabelType {
  Activity = 'ACTIVITY',
  Billing = 'BILLING',
  Client = 'CLIENT',
  Comment = 'COMMENT',
  Numeric = 'NUMERIC',
  Program = 'PROGRAM',
  Project = 'PROJECT',
  Select = 'SELECT',
  Task = 'TASK',
  Text = 'TEXT',
  Textselect = 'TEXTSELECT'
}

export type LabelValue = {
  __typename?: 'LabelValue';
  idValue?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  stringValue?: Maybe<Scalars['String']>;
};

export type LabelValueDetails = {
  __typename?: 'LabelValueDetails';
  label: Label;
  suggestedValues?: Maybe<Array<Maybe<LabelValue>>>;
  suggestionMetadata?: Maybe<Scalars['String']>;
  value?: Maybe<LabelValue>;
  valueSource: LabelValueSource;
};

export type LabelValueDetailsInput = {
  labelId: Scalars['String'];
  suggestedValues?: Maybe<Array<Maybe<LabelValueInput>>>;
  suggestionMetadata?: Maybe<Scalars['String']>;
  value?: Maybe<LabelValueInput>;
  valueSource?: Maybe<LabelValueSource>;
};

export type LabelValueInput = {
  idValue?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  stringValue?: Maybe<Scalars['String']>;
};

export enum LabelValueSource {
  Suggestion = 'SUGGESTION',
  User = 'USER'
}

export type LabelsResult = {
  __typename?: 'LabelsResult';
  items: Array<Label>;
};

export type Language = {
  __typename?: 'Language';
  cultureCode: Scalars['String'];
  displayText: Scalars['String'];
  languageCode: Scalars['String'];
  uri: Scalars['String'];
};

export type Locale = {
  __typename?: 'Locale';
  customTerms: Array<CustomTerm>;
  dateTimeSettings: DateTimeSetting;
  language: Language;
  timeZone: TimeZone;
};

export type Maintainer = {
  __typename?: 'Maintainer';
  displayText: Scalars['String'];
  userId: Scalars['String'];
};

export type Me = {
  __typename?: 'Me';
  companyKey: Scalars['String'];
  displayText: Scalars['String'];
  featureFlags: FeatureFlags;
  firstName: Scalars['String'];
  id: Scalars['String'];
  isAutoAcceptEnabled?: Maybe<Scalars['Boolean']>;
  isSmartSuggestionEnabled?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  locale: Locale;
  loginName: Scalars['String'];
  permissions: UserPermission;
  session: Session;
  showStartEndFields?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  tenantSlug: Scalars['String'];
  workWeekStartDay: WorkWeek;
  wtsUiEndpoint: Scalars['String'];
};

export type MergeTimeSignalsInput = {
  ids: Array<Scalars['String']>;
  timeSignal: CreateTimeSignalInput;
};

export type MergeTimeSignalsResult = {
  __typename?: 'MergeTimeSignalsResult';
  mergedTimeSignals: Array<TimeSignal>;
  timeSignal: TimeSignal;
};

export type Mutation = {
  __typename?: 'Mutation';
  appendInstallError?: Maybe<AppendInstallErrorResult>;
  confirmCollectorInstallV2?: Maybe<ConfirmCollectorInstallV2Result>;
  confirmUserCollectorInstallV2?: Maybe<ConfirmUserCollectorInstallV2Result>;
  createCustomLabel: CreateCustomLabelResult;
  createCustomLabelOptions: CreateCustomLabelOptionsResult;
  createTimeSignal: CreateTimeSignalResult;
  deleteCustomLabel: DeleteCustomLabelResult;
  deleteCustomLabelOptions: DeleteCustomLabelOptionsResult;
  deleteTimeSignal: DeleteTimeSignalResult;
  deleteTimeSignals: DeleteTimeSignalsResult;
  disableInstallError?: Maybe<DisableInstallErrorResult>;
  disconnectUserCollector?: Maybe<DisconnectUserCollectorResult>;
  installCollector?: Maybe<InstallCollectorResult>;
  installUserCollector?: Maybe<InstallUserCollectorResult>;
  mergeTimeSignals: MergeTimeSignalsResult;
  putAnalyticsMetadata?: Maybe<PutAnalyticsMetadataResult>;
  putAutoAcceptSettings?: Maybe<PutAutoAcceptSettingResult>;
  putSmartSuggestionSettings?: Maybe<PutSmartSuggestionSettingResult>;
  putStartEndSettings?: Maybe<PutStartEndSettingResult>;
  resuggestLabelSuggestions?: Maybe<ResuggestLabelSuggestionsResult>;
  retryInstallationFlow?: Maybe<RetryInstallationFlowResult>;
  splitTimeSignal: SplitTimeSignalResult;
  syncDiaryToTimesheet: SyncDiaryToTimesheetResult;
  trainLabelSuggestions?: Maybe<TrainLabelSuggestionsResult>;
  uninstallCollector?: Maybe<UninstallCollectorResult>;
  uninstallUserCollector?: Maybe<UninstallUserCollectorResult>;
  updateCollectorInstall?: Maybe<UpdateCollectorInstallResult>;
  updateCustomLabel: UpdateCustomLabelResult;
  updateCustomLabelOptions: UpdateCustomLabelOptionsResult;
  /** @deprecated use UpdateCollectorInstall instead */
  updateSettingPreferencesForCollectorSetting?: Maybe<UpdateSettingPreferencesForCollectorSettingResult>;
  updateTimeSignal: UpdateTimeSignalResult;
  updateTimeSignals: UpdateTimeSignalsResult;
  updateUserPreferenceForTenantCollectorSetting?: Maybe<UpdateUserPreferenceForTenantCollectorSettingResult>;
};


export type MutationAppendInstallErrorArgs = {
  input: AppendInstallErrorInput;
};


export type MutationConfirmCollectorInstallV2Args = {
  input: ConfirmCollectorInstallV2Input;
};


export type MutationConfirmUserCollectorInstallV2Args = {
  input: ConfirmUserCollectorInstallV2Input;
};


export type MutationCreateCustomLabelArgs = {
  input: CreateCustomLabelInput;
};


export type MutationCreateCustomLabelOptionsArgs = {
  input: CreateCustomLabelOptionsInput;
};


export type MutationCreateTimeSignalArgs = {
  input: CreateTimeSignalInput;
};


export type MutationDeleteCustomLabelArgs = {
  input: DeleteCustomLabelInput;
};


export type MutationDeleteCustomLabelOptionsArgs = {
  input: DeleteCustomLabelOptionsInput;
};


export type MutationDeleteTimeSignalArgs = {
  input: DeleteTimeSignalInput;
};


export type MutationDeleteTimeSignalsArgs = {
  input: DeleteTimeSignalsInput;
};


export type MutationDisableInstallErrorArgs = {
  input: DisableInstallErrorInput;
};


export type MutationDisconnectUserCollectorArgs = {
  input: DisconnectUserCollectorInput;
};


export type MutationInstallCollectorArgs = {
  collectorId: Scalars['String'];
};


export type MutationInstallUserCollectorArgs = {
  collectorId: Scalars['String'];
};


export type MutationMergeTimeSignalsArgs = {
  input: MergeTimeSignalsInput;
};


export type MutationPutAnalyticsMetadataArgs = {
  input: PutAnalyticsMetadataInput;
};


export type MutationPutAutoAcceptSettingsArgs = {
  input: PutAutoAcceptSettingInput;
};


export type MutationPutSmartSuggestionSettingsArgs = {
  input: PutSmartSuggestionSettingInput;
};


export type MutationPutStartEndSettingsArgs = {
  input: PutStartEndSettingInput;
};


export type MutationRetryInstallationFlowArgs = {
  input?: Maybe<RetryInstallationFlowInput>;
};


export type MutationSplitTimeSignalArgs = {
  input: SplitTimeSignalInput;
};


export type MutationSyncDiaryToTimesheetArgs = {
  input: SyncDiaryToTimesheetInput;
};


export type MutationTrainLabelSuggestionsArgs = {
  user: Scalars['String'];
};


export type MutationUninstallCollectorArgs = {
  collectorId: Scalars['String'];
  sessionId?: Maybe<Scalars['String']>;
};


export type MutationUninstallUserCollectorArgs = {
  collectorId: Scalars['String'];
  sessionId?: Maybe<Scalars['String']>;
};


export type MutationUpdateCollectorInstallArgs = {
  input: UpdateCollectorInstallInput;
};


export type MutationUpdateCustomLabelArgs = {
  input: UpdateCustomLabelInput;
};


export type MutationUpdateCustomLabelOptionsArgs = {
  input: UpdateCustomLabelOptionsInput;
};


export type MutationUpdateSettingPreferencesForCollectorSettingArgs = {
  input: UpdateSettingPreferencesForCollectorSettingInput;
};


export type MutationUpdateTimeSignalArgs = {
  input: UpdateTimeSignalInput;
};


export type MutationUpdateTimeSignalsArgs = {
  input: UpdateTimeSignalsInput;
};


export type MutationUpdateUserPreferenceForTenantCollectorSettingArgs = {
  input: UpdateUserPreferenceForTenantCollectorSettingInput;
};

export type Period = {
  __typename?: 'Period';
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type PeriodsFilter = {
  fromDate?: Maybe<Scalars['Date']>;
  toDate?: Maybe<Scalars['Date']>;
};

export type PeriodsInput = {
  count?: Maybe<Scalars['Int']>;
  filter?: Maybe<PeriodsFilter>;
  sort?: Maybe<SortOrder>;
};

export type PeriodsResult = {
  __typename?: 'PeriodsResult';
  items: Array<Period>;
};

export type PutAnalyticsMetadataInput = {
  metadata?: Maybe<Array<AnalyticsMetaDataValueInput>>;
  type: AnalyticsMetadataType;
};

export type PutAnalyticsMetadataResult = {
  __typename?: 'PutAnalyticsMetadataResult';
  userId: Scalars['String'];
};

export type PutAutoAcceptSettingInput = {
  enabled: Scalars['Boolean'];
};

export type PutAutoAcceptSettingResult = {
  __typename?: 'PutAutoAcceptSettingResult';
  id: Scalars['String'];
};

export type PutSmartSuggestionSettingInput = {
  settings: Array<SmartSuggestionSettingsInput>;
};

export type PutSmartSuggestionSettingResult = {
  __typename?: 'PutSmartSuggestionSettingResult';
  id: Scalars['String'];
};

export type PutStartEndSettingInput = {
  settings: Array<StartEndSettingsInput>;
};

export type PutStartEndSettingResult = {
  __typename?: 'PutStartEndSettingResult';
  id: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  analyticsMetadata?: Maybe<AnalyticsMetadataResult>;
  collector?: Maybe<CollectorResult>;
  collectorSetting?: Maybe<CollectorSettingResult>;
  collectorSettings?: Maybe<CollectorSettingsResult>;
  collectors: CollectorsResult;
  dataSciencePerformanceAnalytics?: Maybe<DataSciencePerformanceAnalyticsResult>;
  diariesForDateRange: DiariesForDateRangeResult;
  diary: Diary;
  enabledGroupTypes?: Maybe<EnabledGroupTypesResult>;
  getAutoAcceptSettings?: Maybe<GetAutoAcceptSettingResult>;
  getSmartSuggestionSettings: GetSmartSuggestionSettingResult;
  getStartEndSettings: GetStartEndSettingResult;
  groupsSearch?: Maybe<GroupsSearch>;
  isTenantCollectorEnabledForUser: Scalars['Boolean'];
  label?: Maybe<Label>;
  labelSuggestions: LabelSuggestionsResult;
  labels?: Maybe<LabelsResult>;
  me?: Maybe<Me>;
  periods?: Maybe<PeriodsResult>;
  startEndTimeFieldsVisible?: Maybe<Scalars['Boolean']>;
  tenantCollectorSettingUserPreferences?: Maybe<CollectorSettingUserPreferencesResult>;
  timeSignal?: Maybe<TimeSignal>;
  timeSignalAnalytics?: Maybe<TimeSignalAnalyticsResult>;
  timeSignalOefAnalytics?: Maybe<TimeSignalAnalyticsResult>;
  timeSignalUtilizationAnalytics?: Maybe<TimeSignalUtilizationResult>;
  timeSignals: TimeSignalsResult;
  timesheetLabelValueSearch?: Maybe<TimesheetLabelValueSearch>;
  userHistoricalLabelValuesSearch: UserHistoricalLabelValuesSearchResult;
  userHistoricalLabels: UserHistoricalLabelResult;
  wbsLabelValueSearch?: Maybe<WbsLabelValueSearch>;
};


export type QueryAnalyticsMetadataArgs = {
  input?: Maybe<AnalyticsMetadataInput>;
};


export type QueryCollectorArgs = {
  id: Scalars['String'];
};


export type QueryCollectorSettingArgs = {
  input: CollectorSettingInput;
};


export type QueryCollectorSettingsArgs = {
  input?: Maybe<CollectorSettingsInput>;
};


export type QueryCollectorsArgs = {
  input?: Maybe<CollectorInput>;
};


export type QueryDiariesForDateRangeArgs = {
  dateRange: DateRangeInput;
};


export type QueryDiaryArgs = {
  date: Scalars['Date'];
};


export type QueryIsTenantCollectorEnabledForUserArgs = {
  input: TenantCollectorEnabledForUserInput;
};


export type QueryLabelArgs = {
  id: Scalars['String'];
};


export type QueryLabelSuggestionsArgs = {
  input: LabelSuggestionsInput;
};


export type QueryLabelsArgs = {
  date: Scalars['Date'];
};


export type QueryPeriodsArgs = {
  input?: Maybe<PeriodsInput>;
};


export type QueryStartEndTimeFieldsVisibleArgs = {
  date: Scalars['Date'];
};


export type QueryTenantCollectorSettingUserPreferencesArgs = {
  input: CollectorSettingUserPreferencesInput;
};


export type QueryTimeSignalArgs = {
  id: Scalars['String'];
};


export type QueryTimeSignalAnalyticsArgs = {
  input?: Maybe<TimeSignalAnalyticsInput>;
};


export type QueryTimeSignalOefAnalyticsArgs = {
  input?: Maybe<TimeSignalOefAnalyticsInput>;
};


export type QueryTimeSignalUtilizationAnalyticsArgs = {
  input?: Maybe<AnalyticsDateRangeFilter>;
};


export type QueryTimeSignalsArgs = {
  input?: Maybe<TimeSignalsInput>;
};


export type QueryTimesheetLabelValueSearchArgs = {
  date: Scalars['Date'];
};


export type QueryUserHistoricalLabelValuesSearchArgs = {
  input: UserHistoricalLabelValuesSearchInput;
};


export type QueryUserHistoricalLabelsArgs = {
  input: UserHistoricalLabelInput;
};


export type QueryWbsLabelValueSearchArgs = {
  date: Scalars['Date'];
};

export type ResuggestLabelSuggestionsResult = {
  __typename?: 'ResuggestLabelSuggestionsResult';
  user?: Maybe<Scalars['String']>;
};

export type RetryInstallationFlowInput = {
  retryURL: Scalars['String'];
};

export type RetryInstallationFlowResult = {
  __typename?: 'RetryInstallationFlowResult';
  status?: Maybe<Scalars['Int']>;
};

export type SelectLabelOption = {
  __typename?: 'SelectLabelOption';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SelectOptionsInput = {
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};

export type SelectOptionsResult = {
  __typename?: 'SelectOptionsResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<SelectLabelOption>;
  totalCount: Scalars['Int'];
};

export type Session = {
  __typename?: 'Session';
  policy: SessionPolicy;
};

export type SessionPolicy = {
  __typename?: 'SessionPolicy';
  timeout?: Maybe<Duration>;
};

export type Setting = {
  __typename?: 'Setting';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SettingInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SmartSuggestionSettings = {
  __typename?: 'SmartSuggestionSettings';
  accessScopeIn?: Maybe<GroupAccessScopeResult>;
  enabled: Scalars['Boolean'];
};

export type SmartSuggestionSettingsInput = {
  accessScopeIn?: Maybe<GroupAccessScopeInput>;
  enabled: Scalars['Boolean'];
};

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SplitTimeSignalInput = {
  id: Scalars['String'];
  timeSignals: Array<CreateTimeSignalInput>;
};

export type SplitTimeSignalResult = {
  __typename?: 'SplitTimeSignalResult';
  timeSignals: Array<TimeSignal>;
};

export type StartEndSettings = {
  __typename?: 'StartEndSettings';
  accessScopeIn?: Maybe<GroupAccessScopeResult>;
  enabled: Scalars['Boolean'];
};

export type StartEndSettingsInput = {
  accessScopeIn?: Maybe<GroupAccessScopeInput>;
  enabled: Scalars['Boolean'];
};

export type SuggestionAttributesInput = {
  name: Scalars['String'];
  sourceId: Scalars['String'];
  value: Scalars['TimeSignalAttributeValue'];
};

export type SuggestionLabelValue = {
  __typename?: 'SuggestionLabelValue';
  idValue?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  stringValue?: Maybe<Scalars['String']>;
};

export type SuggestionLabelValueDetailsInput = {
  labelId: Scalars['String'];
  value?: Maybe<SuggestionLabelValueInput>;
  valueSource?: Maybe<SuggestionLabelValueSource>;
};

export type SuggestionLabelValueInput = {
  idValue?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  stringValue?: Maybe<Scalars['String']>;
};

export enum SuggestionLabelValueSource {
  Suggestion = 'SUGGESTION',
  User = 'USER'
}

export type SyncDiaryEntryResult = {
  __typename?: 'SyncDiaryEntryResult';
  entry: DiaryEntry;
  error?: Maybe<DiaryError>;
};

export type SyncDiaryResult = {
  __typename?: 'SyncDiaryResult';
  entries: Array<SyncDiaryEntryResult>;
};

export type SyncDiaryToTimesheetInput = {
  date?: Maybe<Scalars['Date']>;
  diaryEntryIds?: Maybe<Array<Scalars['String']>>;
  diaryEntryIdsToSync?: Maybe<Array<Scalars['String']>>;
  diaryEntryIdsToUnsync?: Maybe<Array<Scalars['String']>>;
};

export type SyncDiaryToTimesheetResult = {
  __typename?: 'SyncDiaryToTimesheetResult';
  /** @deprecated Explicitly query for the updated diary state after the mutation instead */
  diary: Diary;
  error?: Maybe<DiaryError>;
  result?: Maybe<SyncDiaryResult>;
};

export type TenantCollectorEnabledForUserInput = {
  collectorId: Scalars['String'];
  userUri: Scalars['String'];
};

export type TimeSignal = {
  __typename?: 'TimeSignal';
  acceptedBy?: Maybe<TimeSignalAcceptedBy>;
  attributes?: Maybe<Array<TimeSignalAttribute>>;
  classification: TimeSignalClassification;
  creationTime: Scalars['DateTime'];
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  excluded?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  labelValues: Array<LabelValueDetails>;
  labelValuesInferenceId?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  modificationTime: Scalars['DateTime'];
  sources: Array<TimeSignalSource>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export enum TimeSignalAcceptedBy {
  System = 'SYSTEM',
  User = 'USER'
}

export type TimeSignalAnalytic = {
  __typename?: 'TimeSignalAnalytic';
  dimensions: Array<TimeSignalDimensionResult>;
  metrics: Array<TimeSignalMetricsResult>;
};

export type TimeSignalAnalyticsInput = {
  dimension: TimeSignalDimensionType;
  filter: AnalyticsDateRangeFilter;
};

export type TimeSignalAnalyticsResult = {
  __typename?: 'TimeSignalAnalyticsResult';
  items: TimeSignalAnalytic;
};

export type TimeSignalAttribute = {
  __typename?: 'TimeSignalAttribute';
  name: Scalars['String'];
  sourceId: Scalars['String'];
  sourceRefs: Array<Maybe<Scalars['String']>>;
  value: Scalars['TimeSignalAttributeValue'];
  visible?: Maybe<Scalars['Boolean']>;
};

export type TimeSignalAttributeInput = {
  name: Scalars['String'];
  sourceId: Scalars['String'];
  sourceRefs: Array<Maybe<Scalars['String']>>;
  value: Scalars['TimeSignalAttributeValue'];
  visible?: Maybe<Scalars['Boolean']>;
};

export enum TimeSignalClassification {
  Accepted = 'ACCEPTED',
  Private = 'PRIVATE',
  Trash = 'TRASH',
  Unclassified = 'UNCLASSIFIED'
}

export type TimeSignalDimensionResult = {
  __typename?: 'TimeSignalDimensionResult';
  dimensionType: TimeSignalDimensionType;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<Maybe<AnalyticsMetaData>>>;
  name: Scalars['String'];
};

export enum TimeSignalDimensionType {
  MetricsByAutoaccept = 'METRICS_BY_AUTOACCEPT',
  MetricsByCategory = 'METRICS_BY_CATEGORY',
  MetricsByClassification = 'METRICS_BY_CLASSIFICATION',
  MetricsByClient = 'METRICS_BY_CLIENT',
  MetricsByKeywords = 'METRICS_BY_KEYWORDS',
  MetricsByOef = 'METRICS_BY_OEF',
  MetricsByProject = 'METRICS_BY_PROJECT',
  MetricsBySource = 'METRICS_BY_SOURCE',
  MetricsByTask = 'METRICS_BY_TASK'
}

export type TimeSignalFilterInput = {
  classifications?: Maybe<Array<TimeSignalClassification>>;
  excludeIds?: Maybe<Array<Scalars['String']>>;
  fromDate?: Maybe<Scalars['Date']>;
  includeIds?: Maybe<Array<Scalars['String']>>;
  labelValues?: Maybe<Array<TimeSignalLabelValueFilterInput>>;
  modifiedFrom?: Maybe<Scalars['DateTime']>;
  modifiedTo?: Maybe<Scalars['DateTime']>;
  searchText?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['Date']>;
};

export type TimeSignalLabelValueFilterInput = {
  idValues: Array<Maybe<Scalars['String']>>;
  labelId: Scalars['String'];
};

export enum TimeSignalMetric {
  SumDuration = 'SUM_DURATION',
  TotalCount = 'TOTAL_COUNT'
}

export type TimeSignalMetricsResult = {
  __typename?: 'TimeSignalMetricsResult';
  totalCount: Scalars['Int'];
  totalDuration: Scalars['Int'];
};

export type TimeSignalOefAnalyticsInput = {
  filter: AnalyticsDateRangeFilter;
  labelId: Scalars['String'];
};

export enum TimeSignalSortField {
  Date = 'DATE',
  EndTime = 'END_TIME',
  StartTime = 'START_TIME'
}

export type TimeSignalSortFieldInput = {
  sortField: TimeSignalSortField;
  sortOrder?: Maybe<SortOrder>;
};

export type TimeSignalSource = {
  __typename?: 'TimeSignalSource';
  id: Scalars['String'];
  image?: Maybe<TimeSignalSourceImage>;
  name: Scalars['String'];
  ref: Scalars['String'];
};

export type TimeSignalSourceImage = {
  __typename?: 'TimeSignalSourceImage';
  src: Scalars['String'];
};

export type TimeSignalSourceImageInput = {
  src: Scalars['String'];
};

export type TimeSignalSourceInput = {
  name: Scalars['String'];
};

export type TimeSignalSourcesInput = {
  id: Scalars['String'];
  image?: Maybe<TimeSignalSourceImageInput>;
  name: Scalars['String'];
  ref: Scalars['String'];
};

export type TimeSignalUtilization = {
  __typename?: 'TimeSignalUtilization';
  categoryName: Scalars['String'];
  data: Array<AnalyticsByDay>;
};

export type TimeSignalUtilizationResult = {
  __typename?: 'TimeSignalUtilizationResult';
  items: Array<TimeSignalUtilization>;
};

export type TimeSignalsInput = {
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  filter?: Maybe<TimeSignalFilterInput>;
  sort?: Maybe<SortOrder>;
  sortFields?: Maybe<Array<TimeSignalSortFieldInput>>;
};

export type TimeSignalsResult = {
  __typename?: 'TimeSignalsResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<TimeSignal>;
  totalCount: Scalars['Int'];
  totalDuration: Scalars['Float'];
};

export type TimeZone = {
  __typename?: 'TimeZone';
  displayText: Scalars['String'];
  ianaName: Scalars['String'];
  uri: Scalars['String'];
};

export type TimesheetBillingRateValueSearchInput = {
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  projectUri: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  taskUri?: Maybe<Scalars['String']>;
};

export type TimesheetLabelValue = {
  __typename?: 'TimesheetLabelValue';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type TimesheetLabelValueResult = {
  __typename?: 'TimesheetLabelValueResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<TimesheetLabelValue>;
  totalCount: Scalars['Int'];
};

export type TimesheetLabelValueSearch = {
  __typename?: 'TimesheetLabelValueSearch';
  activities?: Maybe<TimesheetLabelValueResult>;
  billingRates?: Maybe<TimesheetLabelValueResult>;
  defaultBillingRate?: Maybe<DefaultBillingRateResult>;
};


export type TimesheetLabelValueSearchActivitiesArgs = {
  input?: Maybe<TimesheetLabelValueSearchInput>;
};


export type TimesheetLabelValueSearchBillingRatesArgs = {
  input?: Maybe<TimesheetBillingRateValueSearchInput>;
};


export type TimesheetLabelValueSearchDefaultBillingRateArgs = {
  input?: Maybe<DefaultBillingRateInput>;
};

export type TimesheetLabelValueSearchInput = {
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};

export type TrainLabelSuggestionsResult = {
  __typename?: 'TrainLabelSuggestionsResult';
  user?: Maybe<Scalars['String']>;
};

export type UninstallCollectorResult = {
  __typename?: 'UninstallCollectorResult';
  collectorId: Scalars['String'];
  installId: Scalars['String'];
};

export type UninstallUserCollectorResult = {
  __typename?: 'UninstallUserCollectorResult';
  collectorId: Scalars['String'];
  installId?: Maybe<Scalars['String']>;
};

export type UpdateCollectorInstallInput = {
  groupSettings?: Maybe<Array<CollectorGroupSettingsInput>>;
  installId?: Maybe<Scalars['String']>;
  maintainerIds?: Maybe<Array<Scalars['String']>>;
  settings?: Maybe<Array<SettingInput>>;
};

export type UpdateCollectorInstallResult = {
  __typename?: 'UpdateCollectorInstallResult';
  collectorInstall: CollectorSetting;
};

export type UpdateCustomLabelInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateCustomLabelOptionsInput = {
  updateOptions: Array<UpdateOptionInput>;
};

export type UpdateCustomLabelOptionsResult = {
  __typename?: 'UpdateCustomLabelOptionsResult';
  customLabelOptions: Array<SelectLabelOption>;
};

export type UpdateCustomLabelResult = {
  __typename?: 'UpdateCustomLabelResult';
  customLabel: Label;
};

export type UpdateLabelValueResult = {
  __typename?: 'UpdateLabelValueResult';
  labelValue: LabelValueDetails;
};

export type UpdateOptionInput = {
  customLabelId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateSettingPreferencesForCollectorSettingInput = {
  groupSettings?: Maybe<Array<CollectorGroupSettingsInput>>;
  installId: Scalars['String'];
  settings: Array<SettingInput>;
};

export type UpdateSettingPreferencesForCollectorSettingResult = {
  __typename?: 'UpdateSettingPreferencesForCollectorSettingResult';
  installId: Scalars['String'];
};

export type UpdateTimeSignalInput = {
  acceptedBy?: Maybe<TimeSignalAcceptedBy>;
  classification?: Maybe<TimeSignalClassification>;
  date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['DateTime']>;
  excluded?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  labelValues?: Maybe<Array<LabelValueDetailsInput>>;
  labelValuesInferenceId?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  sources?: Maybe<Array<TimeSignalSourcesInput>>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export type UpdateTimeSignalResult = {
  __typename?: 'UpdateTimeSignalResult';
  timeSignal: TimeSignal;
};

export type UpdateTimeSignalsFieldsInput = {
  acceptedBy?: Maybe<TimeSignalAcceptedBy>;
  classification?: Maybe<TimeSignalClassification>;
  excluded?: Maybe<Scalars['Boolean']>;
  labelValues?: Maybe<Array<LabelValueDetailsInput>>;
};

export type UpdateTimeSignalsInput = {
  cursor?: Maybe<Scalars['String']>;
  selectionFilter: TimeSignalFilterInput;
  updates: UpdateTimeSignalsFieldsInput;
};

export type UpdateTimeSignalsResult = {
  __typename?: 'UpdateTimeSignalsResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<TimeSignal>;
};

export type UpdateUserPreferenceForTenantCollectorSettingInput = {
  installId: Scalars['String'];
  settings: Array<SettingInput>;
};

export type UpdateUserPreferenceForTenantCollectorSettingResult = {
  __typename?: 'UpdateUserPreferenceForTenantCollectorSettingResult';
  installId: Scalars['String'];
};

export enum UserHistoricalLabelFilter {
  All = 'ALL',
  IncludeOnlyLabelValueSet = 'INCLUDE_ONLY_LABEL_VALUE_SET'
}

export type UserHistoricalLabelInput = {
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  include?: Maybe<UserHistoricalLabelFilter>;
};

export type UserHistoricalLabelResult = {
  __typename?: 'UserHistoricalLabelResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<Label>;
};

export type UserHistoricalLabelValuesSearchInput = {
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  labelId: Scalars['String'];
  searchText?: Maybe<Scalars['String']>;
};

export type UserHistoricalLabelValuesSearchResult = {
  __typename?: 'UserHistoricalLabelValuesSearchResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<LabelValue>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  hasCompanyCollectorInstallAccess: Scalars['Boolean'];
  hasLoginAccess: Scalars['Boolean'];
  hasPsaAccess: Scalars['Boolean'];
  hasSmartSuggestionEditAccess?: Maybe<Scalars['Boolean']>;
  hasStartEndEditAccess?: Maybe<Scalars['Boolean']>;
  hasTimesheetAccess: Scalars['Boolean'];
  hasViewCollectorsAccess: Scalars['Boolean'];
};

export type WbsLabelValueFilterInput = {
  client?: Maybe<Scalars['String']>;
  clientCoManager?: Maybe<Scalars['String']>;
  clientManager?: Maybe<Scalars['String']>;
  clientRepresentative?: Maybe<Scalars['String']>;
  program?: Maybe<Scalars['String']>;
  programCoManager?: Maybe<Scalars['String']>;
  programManager?: Maybe<Scalars['String']>;
  project?: Maybe<Scalars['String']>;
  projectCoManager?: Maybe<Scalars['String']>;
  projectCostCenter?: Maybe<Scalars['String']>;
  projectDepartment?: Maybe<Scalars['String']>;
  projectDivision?: Maybe<Scalars['String']>;
  projectEmployeeType?: Maybe<Scalars['String']>;
  projectLocation?: Maybe<Scalars['String']>;
  projectManager?: Maybe<Scalars['String']>;
  projectServiceCenter?: Maybe<Scalars['String']>;
  projectTags?: Maybe<Array<WbsProjectTagFilterValueInput>>;
};

export type WbsLabelValueSearch = {
  __typename?: 'WbsLabelValueSearch';
  clients: WbsLabelValueSearchResults;
  programs: WbsLabelValueSearchResults;
  projects: WbsLabelValueSearchResults;
  tasks: WbsTaskSearchResults;
};


export type WbsLabelValueSearchClientsArgs = {
  input?: Maybe<WbsLabelValueSearchInput>;
};


export type WbsLabelValueSearchProgramsArgs = {
  input?: Maybe<WbsLabelValueSearchInput>;
};


export type WbsLabelValueSearchProjectsArgs = {
  input?: Maybe<WbsLabelValueSearchInput>;
};


export type WbsLabelValueSearchTasksArgs = {
  input?: Maybe<WbsLabelValueSearchInput>;
};

export type WbsLabelValueSearchInput = {
  count?: Maybe<Scalars['Int']>;
  filter?: Maybe<WbsLabelValueFilterInput>;
  query?: Maybe<Scalars['String']>;
};

export type WbsLabelValueSearchResult = {
  __typename?: 'WbsLabelValueSearchResult';
  displayText: Scalars['String'];
  id?: Maybe<Scalars['String']>;
};

export type WbsLabelValueSearchResults = {
  __typename?: 'WbsLabelValueSearchResults';
  items: Array<WbsLabelValueSearchResult>;
};

export type WbsProjectTagFilterValueInput = {
  tag: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type WbsTaskParentSearchResult = {
  __typename?: 'WbsTaskParentSearchResult';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type WbsTaskSearchResult = {
  __typename?: 'WbsTaskSearchResult';
  displayText: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  parents: Array<WbsTaskParentSearchResult>;
};

export type WbsTaskSearchResults = {
  __typename?: 'WbsTaskSearchResults';
  items: Array<WbsTaskSearchResult>;
};

export type WorkWeek = {
  __typename?: 'WorkWeek';
  displayText?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type DeleteTimeSignalsMutationVariables = Exact<{
  input: DeleteTimeSignalsInput;
}>;


export type DeleteTimeSignalsMutation = { __typename?: 'Mutation', deleteTimeSignals: { __typename?: 'DeleteTimeSignalsResult', ids: Array<string>, cursor?: string | null | undefined } };

export type UpdateTimeSignalsMutationVariables = Exact<{
  input: UpdateTimeSignalsInput;
}>;


export type UpdateTimeSignalsMutation = { __typename?: 'Mutation', updateTimeSignals: { __typename?: 'UpdateTimeSignalsResult', cursor?: string | null | undefined, items: Array<{ __typename?: 'TimeSignal', id: string }> } };

export type CreateCustomLabelMutationVariables = Exact<{
  input: CreateCustomLabelInput;
}>;


export type CreateCustomLabelMutation = { __typename?: 'Mutation', createCustomLabel: { __typename?: 'CreateCustomLabelResult', customLabel: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined } } };

export type CreateCustomLabelOptionsMutationVariables = Exact<{
  input: CreateCustomLabelOptionsInput;
}>;


export type CreateCustomLabelOptionsMutation = { __typename?: 'Mutation', createCustomLabelOptions: { __typename?: 'CreateCustomLabelOptionsResult', customLabelOptions: Array<{ __typename?: 'SelectLabelOption', id: string, name: string }> } };

export type CreateTimeSignalMutationVariables = Exact<{
  input: CreateTimeSignalInput;
}>;


export type CreateTimeSignalMutation = { __typename?: 'Mutation', createTimeSignal: { __typename?: 'CreateTimeSignalResult', timeSignal: { __typename?: 'TimeSignal', id: string, date: any, creationTime: any, modificationTime: any, startTime?: any | null | undefined, endTime?: any | null | undefined, duration?: number | null | undefined, description?: string | null | undefined, classification: TimeSignalClassification, excluded?: boolean | null | undefined, labelValuesInferenceId?: string | null | undefined, labelValues: Array<{ __typename?: 'LabelValueDetails', suggestionMetadata?: string | null | undefined, valueSource: LabelValueSource, label: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, suggestedValues?: Array<{ __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined> | null | undefined }>, sources: Array<{ __typename?: 'TimeSignalSource', id: string, name: string, ref: string, image?: { __typename?: 'TimeSignalSourceImage', src: string } | null | undefined }> } } };

export type DeleteCustomLabelMutationVariables = Exact<{
  input: DeleteCustomLabelInput;
}>;


export type DeleteCustomLabelMutation = { __typename?: 'Mutation', deleteCustomLabel: { __typename?: 'DeleteCustomLabelResult', id: string } };

export type DeleteCustomLabelOptionsMutationVariables = Exact<{
  input: DeleteCustomLabelOptionsInput;
}>;


export type DeleteCustomLabelOptionsMutation = { __typename?: 'Mutation', deleteCustomLabelOptions: { __typename?: 'DeleteCustomLabelOptionsResult', ids: Array<string> } };

export type DeleteTimeSignalMutationVariables = Exact<{
  input: DeleteTimeSignalInput;
}>;


export type DeleteTimeSignalMutation = { __typename?: 'Mutation', deleteTimeSignal: { __typename?: 'DeleteTimeSignalResult', id: string } };

export type DisconnectUserCollectorMutationVariables = Exact<{
  input: DisconnectUserCollectorInput;
}>;


export type DisconnectUserCollectorMutation = { __typename?: 'Mutation', disconnectUserCollector?: { __typename?: 'DisconnectUserCollectorResult', status?: number | null | undefined } | null | undefined };

export type InstallCollectorMutationVariables = Exact<{
  collectorId: Scalars['String'];
}>;


export type InstallCollectorMutation = { __typename?: 'Mutation', installCollector?: { __typename?: 'InstallCollectorResult', collectorId: string, installId: string } | null | undefined };

export type InstallUserCollectorMutationVariables = Exact<{
  collectorId: Scalars['String'];
}>;


export type InstallUserCollectorMutation = { __typename?: 'Mutation', installUserCollector?: { __typename?: 'InstallUserCollectorResult', collectorId: string } | null | undefined };

export type MergeTimeSignalsMutationVariables = Exact<{
  input: MergeTimeSignalsInput;
}>;


export type MergeTimeSignalsMutation = { __typename?: 'Mutation', mergeTimeSignals: { __typename?: 'MergeTimeSignalsResult', timeSignal: { __typename?: 'TimeSignal', id: string, date: any, creationTime: any, modificationTime: any, startTime?: any | null | undefined, endTime?: any | null | undefined, duration?: number | null | undefined, description?: string | null | undefined, classification: TimeSignalClassification, excluded?: boolean | null | undefined, labelValuesInferenceId?: string | null | undefined, labelValues: Array<{ __typename?: 'LabelValueDetails', suggestionMetadata?: string | null | undefined, valueSource: LabelValueSource, label: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, suggestedValues?: Array<{ __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined> | null | undefined }>, sources: Array<{ __typename?: 'TimeSignalSource', id: string, name: string, ref: string, image?: { __typename?: 'TimeSignalSourceImage', src: string } | null | undefined }> }, mergedTimeSignals: Array<{ __typename?: 'TimeSignal', id: string }> } };

export type PutAnalyticsMetaDataMutationVariables = Exact<{
  input: PutAnalyticsMetadataInput;
}>;


export type PutAnalyticsMetaDataMutation = { __typename?: 'Mutation', putAnalyticsMetadata?: { __typename?: 'PutAnalyticsMetadataResult', userId: string } | null | undefined };

export type PutAutoAcceptSettingsMutationVariables = Exact<{
  input: PutAutoAcceptSettingInput;
}>;


export type PutAutoAcceptSettingsMutation = { __typename?: 'Mutation', putAutoAcceptSettings?: { __typename?: 'PutAutoAcceptSettingResult', id: string } | null | undefined };

export type PutSmartSuggestionSettingsMutationVariables = Exact<{
  input: PutSmartSuggestionSettingInput;
}>;


export type PutSmartSuggestionSettingsMutation = { __typename?: 'Mutation', putSmartSuggestionSettings?: { __typename?: 'PutSmartSuggestionSettingResult', id: string } | null | undefined };

export type PutStartEndSettingsMutationVariables = Exact<{
  input: PutStartEndSettingInput;
}>;


export type PutStartEndSettingsMutation = { __typename?: 'Mutation', putStartEndSettings?: { __typename?: 'PutStartEndSettingResult', id: string } | null | undefined };

export type RetryInstallationFlowMutationVariables = Exact<{
  input: RetryInstallationFlowInput;
}>;


export type RetryInstallationFlowMutation = { __typename?: 'Mutation', retryInstallationFlow?: { __typename?: 'RetryInstallationFlowResult', status?: number | null | undefined } | null | undefined };

export type SplitTimeSingalMutationVariables = Exact<{
  input: SplitTimeSignalInput;
}>;


export type SplitTimeSingalMutation = { __typename?: 'Mutation', splitTimeSignal: { __typename?: 'SplitTimeSignalResult', timeSignals: Array<{ __typename?: 'TimeSignal', id: string, date: any, creationTime: any, modificationTime: any, startTime?: any | null | undefined, endTime?: any | null | undefined, duration?: number | null | undefined, description?: string | null | undefined, classification: TimeSignalClassification, excluded?: boolean | null | undefined, labelValuesInferenceId?: string | null | undefined, labelValues: Array<{ __typename?: 'LabelValueDetails', suggestionMetadata?: string | null | undefined, valueSource: LabelValueSource, label: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, suggestedValues?: Array<{ __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined> | null | undefined }>, sources: Array<{ __typename?: 'TimeSignalSource', id: string, name: string, ref: string, image?: { __typename?: 'TimeSignalSourceImage', src: string } | null | undefined }> }> } };

export type SyncDiaryToTimesheetMutationVariables = Exact<{
  input: SyncDiaryToTimesheetInput;
}>;


export type SyncDiaryToTimesheetMutation = { __typename?: 'Mutation', syncDiaryToTimesheet: { __typename?: 'SyncDiaryToTimesheetResult', result?: { __typename?: 'SyncDiaryResult', entries: Array<{ __typename?: 'SyncDiaryEntryResult', entry: { __typename?: 'DiaryEntry', id: string }, error?: { __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string } | null | undefined }> } | null | undefined, error?: { __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string } | null | undefined } };

export type TrainLabelSuggestionsMutationVariables = Exact<{
  user: Scalars['String'];
}>;


export type TrainLabelSuggestionsMutation = { __typename?: 'Mutation', trainLabelSuggestions?: { __typename?: 'TrainLabelSuggestionsResult', user?: string | null | undefined } | null | undefined };

export type UninstallCollectorMutationVariables = Exact<{
  collectorId: Scalars['String'];
}>;


export type UninstallCollectorMutation = { __typename?: 'Mutation', uninstallCollector?: { __typename?: 'UninstallCollectorResult', collectorId: string } | null | undefined };

export type UninstallUserCollectorMutationVariables = Exact<{
  collectorId: Scalars['String'];
}>;


export type UninstallUserCollectorMutation = { __typename?: 'Mutation', uninstallUserCollector?: { __typename?: 'UninstallUserCollectorResult', collectorId: string } | null | undefined };

export type UpdateCustomLabelMutationVariables = Exact<{
  input: UpdateCustomLabelInput;
}>;


export type UpdateCustomLabelMutation = { __typename?: 'Mutation', updateCustomLabel: { __typename?: 'UpdateCustomLabelResult', customLabel: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined } } };

export type UpdateCustomLabelOptionsMutationVariables = Exact<{
  input: UpdateCustomLabelOptionsInput;
}>;


export type UpdateCustomLabelOptionsMutation = { __typename?: 'Mutation', updateCustomLabelOptions: { __typename?: 'UpdateCustomLabelOptionsResult', customLabelOptions: Array<{ __typename?: 'SelectLabelOption', id: string, name: string }> } };

export type UpdateSettingPreferencesForCollectorSettingMutationVariables = Exact<{
  input: UpdateSettingPreferencesForCollectorSettingInput;
}>;


export type UpdateSettingPreferencesForCollectorSettingMutation = { __typename?: 'Mutation', updateSettingPreferencesForCollectorSetting?: { __typename?: 'UpdateSettingPreferencesForCollectorSettingResult', installId: string } | null | undefined };

export type UpdateTimeSignalMutationVariables = Exact<{
  input: UpdateTimeSignalInput;
}>;


export type UpdateTimeSignalMutation = { __typename?: 'Mutation', updateTimeSignal: { __typename?: 'UpdateTimeSignalResult', timeSignal: { __typename?: 'TimeSignal', id: string, date: any, creationTime: any, modificationTime: any, startTime?: any | null | undefined, endTime?: any | null | undefined, duration?: number | null | undefined, description?: string | null | undefined, classification: TimeSignalClassification, excluded?: boolean | null | undefined, labelValuesInferenceId?: string | null | undefined, labelValues: Array<{ __typename?: 'LabelValueDetails', suggestionMetadata?: string | null | undefined, valueSource: LabelValueSource, label: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, suggestedValues?: Array<{ __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined> | null | undefined }>, sources: Array<{ __typename?: 'TimeSignalSource', id: string, name: string, ref: string, image?: { __typename?: 'TimeSignalSourceImage', src: string } | null | undefined }> } } };

export type UpdateUserPreferenceForTenantCollectorSettingMutationVariables = Exact<{
  input: UpdateUserPreferenceForTenantCollectorSettingInput;
}>;


export type UpdateUserPreferenceForTenantCollectorSettingMutation = { __typename?: 'Mutation', updateUserPreferenceForTenantCollectorSetting?: { __typename?: 'UpdateUserPreferenceForTenantCollectorSettingResult', installId: string } | null | undefined };

export type ActivityLabelOptionsQueryVariables = Exact<{
  date: Scalars['Date'];
  input?: Maybe<TimesheetLabelValueSearchInput>;
}>;


export type ActivityLabelOptionsQuery = { __typename?: 'Query', timesheetLabelValueSearch?: { __typename?: 'TimesheetLabelValueSearch', activities?: { __typename?: 'TimesheetLabelValueResult', cursor?: string | null | undefined, totalCount: number, items: Array<{ __typename?: 'TimesheetLabelValue', id: string, name?: string | null | undefined }> } | null | undefined } | null | undefined };

export type AllCollectorsQueryVariables = Exact<{
  input?: Maybe<CollectorInput>;
}>;


export type AllCollectorsQuery = { __typename?: 'Query', collectors: { __typename?: 'CollectorsResult', items: Array<{ __typename?: 'Collector', id: string, name: string, type: CollectorType, publishedBy: string, category: string, retryURL?: string | null | undefined, configURL?: string | null | undefined, description?: string | null | undefined, installURL?: string | null | undefined, uninstallURL?: string | null | undefined, userInstallURL?: string | null | undefined, userUninstallURL?: string | null | undefined, appScope?: Array<string | null | undefined> | null | undefined, image: { __typename?: 'CollectorLogo', src: string }, installations?: { __typename?: 'CollectorInstallations', items?: Array<{ __typename?: 'CollectorInstallation', scope: CollectorSettingScope, installId: string } | null | undefined> | null | undefined } | null | undefined }> } };

export type AnalyticsMetaDataQueryVariables = Exact<{
  input?: Maybe<AnalyticsMetadataInput>;
}>;


export type AnalyticsMetaDataQuery = { __typename?: 'Query', analyticsMetadata?: { __typename?: 'AnalyticsMetadataResult', metadata?: Array<{ __typename?: 'AnalyticsMetaDataValue', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetAutoAcceptSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutoAcceptSettingsQuery = { __typename?: 'Query', getAutoAcceptSettings?: { __typename?: 'GetAutoAcceptSettingResult', enabled: boolean } | null | undefined };

export type BillingLabelOptionsQueryVariables = Exact<{
  date: Scalars['Date'];
  input?: Maybe<TimesheetBillingRateValueSearchInput>;
}>;


export type BillingLabelOptionsQuery = { __typename?: 'Query', timesheetLabelValueSearch?: { __typename?: 'TimesheetLabelValueSearch', billingRates?: { __typename?: 'TimesheetLabelValueResult', cursor?: string | null | undefined, totalCount: number, items: Array<{ __typename?: 'TimesheetLabelValue', id: string, name?: string | null | undefined }> } | null | undefined } | null | undefined };

export type CollectorQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type CollectorQuery = { __typename?: 'Query', collector?: { __typename?: 'CollectorResult', item?: { __typename?: 'Collector', id: string, name: string, retryURL?: string | null | undefined, configURL?: string | null | undefined, installURL?: string | null | undefined, uninstallURL?: string | null | undefined, userInstallURL?: string | null | undefined, userUninstallURL?: string | null | undefined, image: { __typename?: 'CollectorLogo', src: string } } | null | undefined } | null | undefined };

export type CollectorSettingQueryVariables = Exact<{
  input: CollectorSettingInput;
}>;


export type CollectorSettingQuery = { __typename?: 'Query', collectorSetting?: { __typename?: 'CollectorSettingResult', item?: { __typename?: 'CollectorSetting', installId: string, collectorId: string, installedDate: any, settings: Array<{ __typename?: 'Setting', key: string, value: string }>, installStatus?: { __typename?: 'CollectorInstallStatus', errors?: Array<{ __typename?: 'CollectorInstallError', errorId: string, title?: string | null | undefined, message: string, date: any } | null | undefined> | null | undefined } | null | undefined, maintainers: Array<{ __typename?: 'Maintainer', displayText: string, userId: string }>, groupSettings?: Array<{ __typename?: 'CollectorGroupSettings', enabled: boolean, canOptOut: boolean, accessScopeIn?: { __typename?: 'GroupAccessScopes', locations?: Array<{ __typename?: 'Group', id: string, name: string }> | null | undefined, divisions?: Array<{ __typename?: 'Group', id: string, name: string }> | null | undefined, costCenters?: Array<{ __typename?: 'Group', id: string, name: string }> | null | undefined, serviceCenters?: Array<{ __typename?: 'Group', id: string, name: string }> | null | undefined, departments?: Array<{ __typename?: 'Group', id: string, name: string }> | null | undefined, employeeTypes?: Array<{ __typename?: 'Group', id: string, name: string }> | null | undefined } | null | undefined }> | null | undefined } | null | undefined } | null | undefined };

export type CollectorSettingsQueryVariables = Exact<{
  input?: Maybe<CollectorSettingsInput>;
}>;


export type CollectorSettingsQuery = { __typename?: 'Query', collectorSettings?: { __typename?: 'CollectorSettingsResult', items: Array<{ __typename?: 'CollectorSetting', installId: string, collectorId: string, installedDate: any, settings: Array<{ __typename?: 'Setting', key: string, value: string }>, installStatus?: { __typename?: 'CollectorInstallStatus', errors?: Array<{ __typename?: 'CollectorInstallError', message: string } | null | undefined> | null | undefined } | null | undefined, collectorMetadata?: { __typename?: 'Collector', name: string, type: CollectorType, retryURL?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CollectorSettingsUnifiedQueryVariables = Exact<{
  input?: Maybe<CollectorSettingsInput>;
}>;


export type CollectorSettingsUnifiedQuery = { __typename?: 'Query', collectorSettings?: { __typename?: 'CollectorSettingsResult', items: Array<{ __typename?: 'CollectorSetting', collectorId: string, scope: CollectorSettingScope, installedDate: any, settings: Array<{ __typename?: 'Setting', key: string, value: string }>, installStatus?: { __typename?: 'CollectorInstallStatus', errors?: Array<{ __typename?: 'CollectorInstallError', message: string } | null | undefined> | null | undefined } | null | undefined, maintainers: Array<{ __typename?: 'Maintainer', displayText: string, userId: string }> } | null | undefined> } | null | undefined };

export type CollectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectorsQuery = { __typename?: 'Query', collectors: { __typename?: 'CollectorsResult', items: Array<{ __typename?: 'Collector', id: string, name: string, type: CollectorType, publishedBy: string, category: string, retryURL?: string | null | undefined, installURL?: string | null | undefined, uninstallURL?: string | null | undefined, appScope?: Array<string | null | undefined> | null | undefined, image: { __typename?: 'CollectorLogo', src: string } }> } };

export type CompanyCollectorsQueryVariables = Exact<{
  input?: Maybe<CollectorInput>;
}>;


export type CompanyCollectorsQuery = { __typename?: 'Query', collectors: { __typename?: 'CollectorsResult', items: Array<{ __typename?: 'Collector', id: string, name: string, type: CollectorType, publishedBy: string, category: string, retryURL?: string | null | undefined, installURL?: string | null | undefined, uninstallURL?: string | null | undefined, image: { __typename?: 'CollectorLogo', src: string } }> } };

export type DiaryQueryVariables = Exact<{
  date: Scalars['Date'];
}>;


export type DiaryQuery = { __typename?: 'Query', diary: { __typename?: 'Diary', date: any, lastSyncTime?: any | null | undefined, taskNameFormat: DiaryTaskNameFormat, entries: Array<{ __typename?: 'DiaryEntry', id: string, syncStatus: DiaryEntrySyncStatus, canBeSynced: boolean, duration?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, lastSyncTime?: any | null | undefined, timeSignals: Array<{ __typename?: 'TimeSignal', id: string, modificationTime: any }>, labelValues: Array<{ __typename?: 'DiaryLabelValue', label: { __typename?: 'Label', id: string, type: LabelType, name: string }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, error?: { __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string } | null | undefined }>, errors: Array<{ __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string }> }> } };

export type DataSciencePerformanceAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSciencePerformanceAnalyticsQuery = { __typename?: 'Query', dataSciencePerformanceAnalytics?: { __typename?: 'DataSciencePerformanceAnalyticsResult', overallAccuracy?: number | null | undefined } | null | undefined };

export type DefaultBillingRateQueryVariables = Exact<{
  date: Scalars['Date'];
  input?: Maybe<DefaultBillingRateInput>;
}>;


export type DefaultBillingRateQuery = { __typename?: 'Query', timesheetLabelValueSearch?: { __typename?: 'TimesheetLabelValueSearch', defaultBillingRate?: { __typename?: 'DefaultBillingRateResult', item?: { __typename?: 'TimesheetLabelValue', id: string, name?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DiariesForDateRangeQueryVariables = Exact<{
  dateRange: DateRangeInput;
}>;


export type DiariesForDateRangeQuery = { __typename?: 'Query', diariesForDateRange: { __typename?: 'DiariesForDateRangeResult', diaries: Array<{ __typename?: 'Diary', date: any, lastSyncTime?: any | null | undefined, taskNameFormat: DiaryTaskNameFormat, entries: Array<{ __typename?: 'DiaryEntry', id: string, syncStatus: DiaryEntrySyncStatus, canBeSynced: boolean, duration?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, lastSyncTime?: any | null | undefined, timeSignals: Array<{ __typename?: 'TimeSignal', id: string, modificationTime: any }>, labelValues: Array<{ __typename?: 'DiaryLabelValue', label: { __typename?: 'Label', id: string, type: LabelType, name: string }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, error?: { __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string } | null | undefined }>, errors: Array<{ __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string }> }> }> } };

export type DiaryEntryFragmentFragment = { __typename?: 'DiaryEntry', id: string, syncStatus: DiaryEntrySyncStatus, canBeSynced: boolean, duration?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, lastSyncTime?: any | null | undefined, timeSignals: Array<{ __typename?: 'TimeSignal', id: string, modificationTime: any }>, labelValues: Array<{ __typename?: 'DiaryLabelValue', label: { __typename?: 'Label', id: string, type: LabelType, name: string }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, error?: { __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string } | null | undefined }>, errors: Array<{ __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string }> };

export type DiaryErrorFragmentFragment = { __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string };

export type DiaryFragmentFragment = { __typename?: 'Diary', date: any, lastSyncTime?: any | null | undefined, taskNameFormat: DiaryTaskNameFormat, entries: Array<{ __typename?: 'DiaryEntry', id: string, syncStatus: DiaryEntrySyncStatus, canBeSynced: boolean, duration?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, lastSyncTime?: any | null | undefined, timeSignals: Array<{ __typename?: 'TimeSignal', id: string, modificationTime: any }>, labelValues: Array<{ __typename?: 'DiaryLabelValue', label: { __typename?: 'Label', id: string, type: LabelType, name: string }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, error?: { __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string } | null | undefined }>, errors: Array<{ __typename?: 'DiaryError', code?: DiaryErrorCode | null | undefined, description: string }> }> };

export type EnabledGroupTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EnabledGroupTypesQuery = { __typename?: 'Query', enabledGroupTypes?: { __typename?: 'EnabledGroupTypesResult', items?: Array<{ __typename?: 'GroupTypeDetails', value: GroupType }> | null | undefined } | null | undefined };

export type CostCentersQueryVariables = Exact<{
  input?: Maybe<GroupSearchInput>;
}>;


export type CostCentersQuery = { __typename?: 'Query', groupsSearch?: { __typename?: 'GroupsSearch', costCenters: { __typename?: 'GroupSearchResults', items: Array<{ __typename?: 'GroupSearchResult', id: string, displayText: string, level: number }> } } | null | undefined };

export type DepartmentsQueryVariables = Exact<{
  input?: Maybe<GroupSearchInput>;
}>;


export type DepartmentsQuery = { __typename?: 'Query', groupsSearch?: { __typename?: 'GroupsSearch', departments: { __typename?: 'GroupSearchResults', items: Array<{ __typename?: 'GroupSearchResult', id: string, displayText: string, level: number }> } } | null | undefined };

export type DivisionsQueryVariables = Exact<{
  input?: Maybe<GroupSearchInput>;
}>;


export type DivisionsQuery = { __typename?: 'Query', groupsSearch?: { __typename?: 'GroupsSearch', divisions: { __typename?: 'GroupSearchResults', items: Array<{ __typename?: 'GroupSearchResult', id: string, displayText: string, level: number }> } } | null | undefined };

export type EmployeeTypesQueryVariables = Exact<{
  input?: Maybe<GroupSearchInput>;
}>;


export type EmployeeTypesQuery = { __typename?: 'Query', groupsSearch?: { __typename?: 'GroupsSearch', employeeTypes: { __typename?: 'GroupSearchResults', items: Array<{ __typename?: 'GroupSearchResult', id: string, displayText: string, level: number }> } } | null | undefined };

export type LocationsQueryVariables = Exact<{
  input?: Maybe<GroupSearchInput>;
}>;


export type LocationsQuery = { __typename?: 'Query', groupsSearch?: { __typename?: 'GroupsSearch', locations: { __typename?: 'GroupSearchResults', items: Array<{ __typename?: 'GroupSearchResult', id: string, displayText: string, level: number }> } } | null | undefined };

export type ServiceCentersQueryVariables = Exact<{
  input?: Maybe<GroupSearchInput>;
}>;


export type ServiceCentersQuery = { __typename?: 'Query', groupsSearch?: { __typename?: 'GroupsSearch', serviceCenters: { __typename?: 'GroupSearchResults', items: Array<{ __typename?: 'GroupSearchResult', id: string, displayText: string, level: number }> } } | null | undefined };

export type InstalledCollectorSettingsQueryVariables = Exact<{
  input?: Maybe<CollectorSettingsInput>;
}>;


export type InstalledCollectorSettingsQuery = { __typename?: 'Query', collectorSettings?: { __typename?: 'CollectorSettingsResult', cursor?: string | null | undefined, items: Array<{ __typename?: 'CollectorSetting', installId: string, collectorId: string, installedDate: any, scope: CollectorSettingScope, canOptOut?: boolean | null | undefined, settings: Array<{ __typename?: 'Setting', key: string, value: string }>, collectorMetadata?: { __typename?: 'Collector', id: string, name: string, installURL?: string | null | undefined, uninstallURL?: string | null | undefined, userInstallURL?: string | null | undefined, userUninstallURL?: string | null | undefined, type: CollectorType, image: { __typename?: 'CollectorLogo', src: string } } | null | undefined, userPreferences: Array<{ __typename?: 'Setting', key: string, value: string }> } | null | undefined> } | null | undefined };

export type LabelSuggestionsQueryVariables = Exact<{
  input: LabelSuggestionsInput;
}>;


export type LabelSuggestionsQuery = { __typename?: 'Query', labelSuggestions: { __typename?: 'LabelSuggestionsResult', startTime?: any | null | undefined, endTime?: any | null | undefined, duration?: number | null | undefined, inferenceId?: string | null | undefined, suggestions: Array<{ __typename?: 'LabelSuggestionDetails', suggestionMetadata?: string | null | undefined, label: { __typename?: 'Label', id: string, type: LabelType, name: string }, suggestedValues: Array<{ __typename?: 'SuggestionLabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined> }> } };

export type LabelValueFragmentFragment = { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined };

export type LabelsQueryVariables = Exact<{
  date: Scalars['Date'];
}>;


export type LabelsQuery = { __typename?: 'Query', labels?: { __typename?: 'LabelsResult', items: Array<{ __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined, defaultValue?: { __typename?: 'DefaultLabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined }> } | null | undefined };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id: string, displayText: string, loginName: string, slug: string, wtsUiEndpoint: string, firstName: string, lastName: string, companyKey: string, showStartEndFields?: boolean | null | undefined, isSmartSuggestionEnabled?: boolean | null | undefined, workWeekStartDay: { __typename?: 'WorkWeek', displayText?: string | null | undefined, uri?: string | null | undefined }, permissions: { __typename?: 'UserPermission', hasViewCollectorsAccess: boolean, hasTimesheetAccess: boolean, hasCompanyCollectorInstallAccess: boolean, hasStartEndEditAccess?: boolean | null | undefined, hasSmartSuggestionEditAccess?: boolean | null | undefined, hasPsaAccess: boolean }, locale: { __typename?: 'Locale', dateTimeSettings: { __typename?: 'DateTimeSetting', shortDateFormat: { __typename?: 'DateTimeFormat', luxonPattern: string }, shortTimeFormat: { __typename?: 'DateTimeFormat', luxonPattern: string } }, language: { __typename?: 'Language', cultureCode: string, displayText: string, uri: string, languageCode: string }, timeZone: { __typename?: 'TimeZone', displayText: string, ianaName: string, uri: string }, customTerms: Array<{ __typename?: 'CustomTerm', originalTerm: string, customTerm: string }> }, featureFlags: { __typename?: 'FeatureFlags', isMenuFeedbackEnabled: boolean, isSmartTimesheetExpandCollapseEnabled: boolean, isTiWebNotesInsightsPageEnabled: boolean, isTiWebTabPersistedCacheQueryEnabled: boolean, isTiAutoAcceptUserSettingsEnabled: boolean, isTIWebGroupViewEnabled: boolean, isShowCollapseAll: boolean, isTiwDurationIndependentStartEndTime: boolean, isBulkEditPerformanceEnabled: boolean, isOfflineImprovementsEnabled: boolean, isSmartTimesheetPerformanceEnabled: boolean, isTiwUnifiedCollectorsTab: boolean, isMyWorkPerformanceEnabled: boolean, isSmartDiaryBetterUxEnabled: boolean, isSessionV2Enabled: boolean, isTiwNewLoginDesign: boolean, isTiwPauseTimesignalPollEnabled: boolean, isTiwSupervisorInsightsEnabled: boolean } } | null | undefined };

export type PeriodsQueryVariables = Exact<{
  input?: Maybe<PeriodsInput>;
}>;


export type PeriodsQuery = { __typename?: 'Query', periods?: { __typename?: 'PeriodsResult', items: Array<{ __typename?: 'Period', startDate: any, endDate: any }> } | null | undefined };

export type SelectLabelOptionsQueryVariables = Exact<{
  id: Scalars['String'];
  input?: Maybe<SelectOptionsInput>;
}>;


export type SelectLabelOptionsQuery = { __typename?: 'Query', label?: { __typename?: 'Label', id: string, name: string, selectOptions?: { __typename?: 'SelectOptionsResult', totalCount: number, cursor?: string | null | undefined, items: Array<{ __typename?: 'SelectLabelOption', id: string, name: string }> } | null | undefined } | null | undefined };

export type GetSmartSuggestionSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmartSuggestionSettingsQuery = { __typename?: 'Query', getSmartSuggestionSettings: { __typename?: 'GetSmartSuggestionSettingResult', settings?: Array<{ __typename?: 'SmartSuggestionSettings', enabled: boolean, accessScopeIn?: { __typename?: 'GroupAccessScopeResult', departmentGroups?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, employeeTypeGroups?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, locations?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, divisions?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, costCenters?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, serviceCenters?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined } | null | undefined }> | null | undefined } };

export type GetStartEndSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStartEndSettingsQuery = { __typename?: 'Query', getStartEndSettings: { __typename?: 'GetStartEndSettingResult', settings?: Array<{ __typename?: 'StartEndSettings', enabled: boolean, accessScopeIn?: { __typename?: 'GroupAccessScopeResult', departmentGroups?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, employeeTypeGroups?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, locations?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, divisions?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, costCenters?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined, serviceCenters?: Array<{ __typename?: 'GroupAccessScope', id: string, displayText: string }> | null | undefined } | null | undefined }> | null | undefined } };

export type TimeSignalAnalyticsQueryVariables = Exact<{
  input?: Maybe<TimeSignalAnalyticsInput>;
}>;


export type TimeSignalAnalyticsQuery = { __typename?: 'Query', timeSignalAnalytics?: { __typename?: 'TimeSignalAnalyticsResult', items: { __typename?: 'TimeSignalAnalytic', dimensions: Array<{ __typename?: 'TimeSignalDimensionResult', dimensionType: TimeSignalDimensionType, id?: string | null | undefined, name: string, metadata?: Array<{ __typename?: 'AnalyticsMetaData', key?: string | null | undefined, value?: string | null | undefined } | null | undefined> | null | undefined }>, metrics: Array<{ __typename?: 'TimeSignalMetricsResult', totalCount: number, totalDuration: number }> } } | null | undefined };

export type TimeSignalAttributesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TimeSignalAttributesQuery = { __typename?: 'Query', timeSignal?: { __typename?: 'TimeSignal', id: string, sources: Array<{ __typename?: 'TimeSignalSource', id: string, name: string, ref: string, image?: { __typename?: 'TimeSignalSourceImage', src: string } | null | undefined }>, attributes?: Array<{ __typename?: 'TimeSignalAttribute', name: string, sourceId: string, sourceRefs: Array<string | null | undefined>, value: any, visible?: boolean | null | undefined }> | null | undefined } | null | undefined };

export type TimeSignalFragmentFragment = { __typename?: 'TimeSignal', id: string, date: any, creationTime: any, modificationTime: any, startTime?: any | null | undefined, endTime?: any | null | undefined, duration?: number | null | undefined, description?: string | null | undefined, classification: TimeSignalClassification, excluded?: boolean | null | undefined, labelValuesInferenceId?: string | null | undefined, labelValues: Array<{ __typename?: 'LabelValueDetails', suggestionMetadata?: string | null | undefined, valueSource: LabelValueSource, label: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, suggestedValues?: Array<{ __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined> | null | undefined }>, sources: Array<{ __typename?: 'TimeSignalSource', id: string, name: string, ref: string, image?: { __typename?: 'TimeSignalSourceImage', src: string } | null | undefined }> };

export type TimeSignalOefAnalyticsQueryVariables = Exact<{
  input?: Maybe<TimeSignalOefAnalyticsInput>;
}>;


export type TimeSignalOefAnalyticsQuery = { __typename?: 'Query', timeSignalOefAnalytics?: { __typename?: 'TimeSignalAnalyticsResult', items: { __typename?: 'TimeSignalAnalytic', dimensions: Array<{ __typename?: 'TimeSignalDimensionResult', dimensionType: TimeSignalDimensionType, id?: string | null | undefined, name: string, metadata?: Array<{ __typename?: 'AnalyticsMetaData', key?: string | null | undefined, value?: string | null | undefined } | null | undefined> | null | undefined }>, metrics: Array<{ __typename?: 'TimeSignalMetricsResult', totalCount: number, totalDuration: number }> } } | null | undefined };

export type TimeSignalUtilizationAnalyticsQueryVariables = Exact<{
  input?: Maybe<AnalyticsDateRangeFilter>;
}>;


export type TimeSignalUtilizationAnalyticsQuery = { __typename?: 'Query', timeSignalUtilizationAnalytics?: { __typename?: 'TimeSignalUtilizationResult', items: Array<{ __typename?: 'TimeSignalUtilization', categoryName: string, data: Array<{ __typename?: 'AnalyticsByDay', date: string, totalCount: number, totalDuration: number }> }> } | null | undefined };

export type TimeSignalsQueryVariables = Exact<{
  input?: Maybe<TimeSignalsInput>;
}>;


export type TimeSignalsQuery = { __typename?: 'Query', timeSignals: { __typename?: 'TimeSignalsResult', totalCount: number, cursor?: string | null | undefined, items: Array<{ __typename?: 'TimeSignal', id: string, date: any, creationTime: any, modificationTime: any, startTime?: any | null | undefined, endTime?: any | null | undefined, duration?: number | null | undefined, description?: string | null | undefined, classification: TimeSignalClassification, excluded?: boolean | null | undefined, labelValuesInferenceId?: string | null | undefined, labelValues: Array<{ __typename?: 'LabelValueDetails', suggestionMetadata?: string | null | undefined, valueSource: LabelValueSource, label: { __typename?: 'Label', id: string, type: LabelType, name: string, origin?: LabelOrigin | null | undefined }, value?: { __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined, suggestedValues?: Array<{ __typename?: 'LabelValue', idValue?: string | null | undefined, stringValue?: string | null | undefined, numericValue?: number | null | undefined } | null | undefined> | null | undefined }>, sources: Array<{ __typename?: 'TimeSignalSource', id: string, name: string, ref: string, image?: { __typename?: 'TimeSignalSourceImage', src: string } | null | undefined }> }> } };

export type TimeSignalsCountQueryVariables = Exact<{
  inputUnClassified?: Maybe<TimeSignalsInput>;
  inputAccepted?: Maybe<TimeSignalsInput>;
  inputPrivate?: Maybe<TimeSignalsInput>;
  inputTrash?: Maybe<TimeSignalsInput>;
}>;


export type TimeSignalsCountQuery = { __typename?: 'Query', unClassified: { __typename?: 'TimeSignalsResult', totalCount: number }, accepted: { __typename?: 'TimeSignalsResult', totalCount: number }, private: { __typename?: 'TimeSignalsResult', totalCount: number }, trash: { __typename?: 'TimeSignalsResult', totalCount: number } };

export type UserCollectorsQueryVariables = Exact<{
  input?: Maybe<CollectorInput>;
}>;


export type UserCollectorsQuery = { __typename?: 'Query', collectors: { __typename?: 'CollectorsResult', items: Array<{ __typename?: 'Collector', id: string, name: string, type: CollectorType, publishedBy: string, category: string, retryURL?: string | null | undefined, installURL?: string | null | undefined, uninstallURL?: string | null | undefined, image: { __typename?: 'CollectorLogo', src: string } }> } };

export type WbsClientLabelSearchQueryVariables = Exact<{
  date: Scalars['Date'];
  input?: Maybe<WbsLabelValueSearchInput>;
}>;


export type WbsClientLabelSearchQuery = { __typename?: 'Query', wbsLabelValueSearch?: { __typename?: 'WbsLabelValueSearch', clients: { __typename?: 'WbsLabelValueSearchResults', items: Array<{ __typename?: 'WbsLabelValueSearchResult', id?: string | null | undefined, displayText: string }> } } | null | undefined };

export type WbsProgramLabelSearchQueryVariables = Exact<{
  date: Scalars['Date'];
  input?: Maybe<WbsLabelValueSearchInput>;
}>;


export type WbsProgramLabelSearchQuery = { __typename?: 'Query', wbsLabelValueSearch?: { __typename?: 'WbsLabelValueSearch', programs: { __typename?: 'WbsLabelValueSearchResults', items: Array<{ __typename?: 'WbsLabelValueSearchResult', id?: string | null | undefined, displayText: string }> } } | null | undefined };

export type WbsProjectLabelSearchQueryVariables = Exact<{
  date: Scalars['Date'];
  input?: Maybe<WbsLabelValueSearchInput>;
}>;


export type WbsProjectLabelSearchQuery = { __typename?: 'Query', wbsLabelValueSearch?: { __typename?: 'WbsLabelValueSearch', projects: { __typename?: 'WbsLabelValueSearchResults', items: Array<{ __typename?: 'WbsLabelValueSearchResult', id?: string | null | undefined, displayText: string }> } } | null | undefined };

export type WbsTaskLabelSearchQueryVariables = Exact<{
  date: Scalars['Date'];
  input?: Maybe<WbsLabelValueSearchInput>;
}>;


export type WbsTaskLabelSearchQuery = { __typename?: 'Query', wbsLabelValueSearch?: { __typename?: 'WbsLabelValueSearch', tasks: { __typename?: 'WbsTaskSearchResults', items: Array<{ __typename?: 'WbsTaskSearchResult', id?: string | null | undefined, displayText: string, parents: Array<{ __typename?: 'WbsTaskParentSearchResult', id: string, displayText: string }> }> } } | null | undefined };

export const LabelValueFragmentFragmentDoc = gql`
    fragment LabelValueFragment on LabelValue {
  idValue
  stringValue
  numericValue
}
    `;
export const DiaryErrorFragmentFragmentDoc = gql`
    fragment DiaryErrorFragment on DiaryError {
  code
  description
}
    `;
export const DiaryEntryFragmentFragmentDoc = gql`
    fragment DiaryEntryFragment on DiaryEntry {
  id
  timeSignals {
    id
    modificationTime
  }
  labelValues {
    label {
      id
      type
      name
    }
    value {
      ...LabelValueFragment
    }
    error {
      ...DiaryErrorFragment
    }
  }
  errors {
    ...DiaryErrorFragment
  }
  syncStatus
  canBeSynced
  duration
  startTime
  endTime
  lastSyncTime
}
    ${LabelValueFragmentFragmentDoc}
${DiaryErrorFragmentFragmentDoc}`;
export const DiaryFragmentFragmentDoc = gql`
    fragment DiaryFragment on Diary {
  date
  entries {
    ...DiaryEntryFragment
  }
  lastSyncTime
  taskNameFormat
}
    ${DiaryEntryFragmentFragmentDoc}`;
export const TimeSignalFragmentFragmentDoc = gql`
    fragment TimeSignalFragment on TimeSignal {
  id
  date
  creationTime
  modificationTime
  startTime
  endTime
  duration
  description
  classification
  excluded
  labelValues {
    label {
      id
      type
      name
      origin
    }
    value {
      ...LabelValueFragment
    }
    suggestedValues {
      ...LabelValueFragment
    }
    suggestionMetadata
    valueSource
  }
  labelValuesInferenceId
  sources {
    id
    name
    ref
    image {
      src
    }
  }
}
    ${LabelValueFragmentFragmentDoc}`;
export const DeleteTimeSignalsDocument = gql`
    mutation deleteTimeSignals($input: DeleteTimeSignalsInput!) {
  deleteTimeSignals(input: $input) {
    ids
    cursor
  }
}
    `;
export type DeleteTimeSignalsMutationFn = Apollo.MutationFunction<DeleteTimeSignalsMutation, DeleteTimeSignalsMutationVariables>;

/**
 * __useDeleteTimeSignalsMutation__
 *
 * To run a mutation, you first call `useDeleteTimeSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeSignalsMutation, { data, loading, error }] = useDeleteTimeSignalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTimeSignalsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeSignalsMutation, DeleteTimeSignalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeSignalsMutation, DeleteTimeSignalsMutationVariables>(DeleteTimeSignalsDocument, options);
      }
export type DeleteTimeSignalsMutationHookResult = ReturnType<typeof useDeleteTimeSignalsMutation>;
export type DeleteTimeSignalsMutationResult = Apollo.MutationResult<DeleteTimeSignalsMutation>;
export type DeleteTimeSignalsMutationOptions = Apollo.BaseMutationOptions<DeleteTimeSignalsMutation, DeleteTimeSignalsMutationVariables>;
export const UpdateTimeSignalsDocument = gql`
    mutation updateTimeSignals($input: UpdateTimeSignalsInput!) {
  updateTimeSignals(input: $input) {
    items {
      id
    }
    cursor
  }
}
    `;
export type UpdateTimeSignalsMutationFn = Apollo.MutationFunction<UpdateTimeSignalsMutation, UpdateTimeSignalsMutationVariables>;

/**
 * __useUpdateTimeSignalsMutation__
 *
 * To run a mutation, you first call `useUpdateTimeSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeSignalsMutation, { data, loading, error }] = useUpdateTimeSignalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeSignalsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeSignalsMutation, UpdateTimeSignalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeSignalsMutation, UpdateTimeSignalsMutationVariables>(UpdateTimeSignalsDocument, options);
      }
export type UpdateTimeSignalsMutationHookResult = ReturnType<typeof useUpdateTimeSignalsMutation>;
export type UpdateTimeSignalsMutationResult = Apollo.MutationResult<UpdateTimeSignalsMutation>;
export type UpdateTimeSignalsMutationOptions = Apollo.BaseMutationOptions<UpdateTimeSignalsMutation, UpdateTimeSignalsMutationVariables>;
export const CreateCustomLabelDocument = gql`
    mutation createCustomLabel($input: CreateCustomLabelInput!) {
  createCustomLabel(input: $input) {
    customLabel {
      id
      type
      name
      origin
    }
  }
}
    `;
export type CreateCustomLabelMutationFn = Apollo.MutationFunction<CreateCustomLabelMutation, CreateCustomLabelMutationVariables>;

/**
 * __useCreateCustomLabelMutation__
 *
 * To run a mutation, you first call `useCreateCustomLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomLabelMutation, { data, loading, error }] = useCreateCustomLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomLabelMutation, CreateCustomLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomLabelMutation, CreateCustomLabelMutationVariables>(CreateCustomLabelDocument, options);
      }
export type CreateCustomLabelMutationHookResult = ReturnType<typeof useCreateCustomLabelMutation>;
export type CreateCustomLabelMutationResult = Apollo.MutationResult<CreateCustomLabelMutation>;
export type CreateCustomLabelMutationOptions = Apollo.BaseMutationOptions<CreateCustomLabelMutation, CreateCustomLabelMutationVariables>;
export const CreateCustomLabelOptionsDocument = gql`
    mutation createCustomLabelOptions($input: CreateCustomLabelOptionsInput!) {
  createCustomLabelOptions(input: $input) {
    customLabelOptions {
      id
      name
    }
  }
}
    `;
export type CreateCustomLabelOptionsMutationFn = Apollo.MutationFunction<CreateCustomLabelOptionsMutation, CreateCustomLabelOptionsMutationVariables>;

/**
 * __useCreateCustomLabelOptionsMutation__
 *
 * To run a mutation, you first call `useCreateCustomLabelOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomLabelOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomLabelOptionsMutation, { data, loading, error }] = useCreateCustomLabelOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomLabelOptionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomLabelOptionsMutation, CreateCustomLabelOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomLabelOptionsMutation, CreateCustomLabelOptionsMutationVariables>(CreateCustomLabelOptionsDocument, options);
      }
export type CreateCustomLabelOptionsMutationHookResult = ReturnType<typeof useCreateCustomLabelOptionsMutation>;
export type CreateCustomLabelOptionsMutationResult = Apollo.MutationResult<CreateCustomLabelOptionsMutation>;
export type CreateCustomLabelOptionsMutationOptions = Apollo.BaseMutationOptions<CreateCustomLabelOptionsMutation, CreateCustomLabelOptionsMutationVariables>;
export const CreateTimeSignalDocument = gql`
    mutation createTimeSignal($input: CreateTimeSignalInput!) {
  createTimeSignal(input: $input) {
    timeSignal {
      ...TimeSignalFragment
    }
  }
}
    ${TimeSignalFragmentFragmentDoc}`;
export type CreateTimeSignalMutationFn = Apollo.MutationFunction<CreateTimeSignalMutation, CreateTimeSignalMutationVariables>;

/**
 * __useCreateTimeSignalMutation__
 *
 * To run a mutation, you first call `useCreateTimeSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeSignalMutation, { data, loading, error }] = useCreateTimeSignalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimeSignalMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeSignalMutation, CreateTimeSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeSignalMutation, CreateTimeSignalMutationVariables>(CreateTimeSignalDocument, options);
      }
export type CreateTimeSignalMutationHookResult = ReturnType<typeof useCreateTimeSignalMutation>;
export type CreateTimeSignalMutationResult = Apollo.MutationResult<CreateTimeSignalMutation>;
export type CreateTimeSignalMutationOptions = Apollo.BaseMutationOptions<CreateTimeSignalMutation, CreateTimeSignalMutationVariables>;
export const DeleteCustomLabelDocument = gql`
    mutation deleteCustomLabel($input: DeleteCustomLabelInput!) {
  deleteCustomLabel(input: $input) {
    id
  }
}
    `;
export type DeleteCustomLabelMutationFn = Apollo.MutationFunction<DeleteCustomLabelMutation, DeleteCustomLabelMutationVariables>;

/**
 * __useDeleteCustomLabelMutation__
 *
 * To run a mutation, you first call `useDeleteCustomLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomLabelMutation, { data, loading, error }] = useDeleteCustomLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomLabelMutation, DeleteCustomLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomLabelMutation, DeleteCustomLabelMutationVariables>(DeleteCustomLabelDocument, options);
      }
export type DeleteCustomLabelMutationHookResult = ReturnType<typeof useDeleteCustomLabelMutation>;
export type DeleteCustomLabelMutationResult = Apollo.MutationResult<DeleteCustomLabelMutation>;
export type DeleteCustomLabelMutationOptions = Apollo.BaseMutationOptions<DeleteCustomLabelMutation, DeleteCustomLabelMutationVariables>;
export const DeleteCustomLabelOptionsDocument = gql`
    mutation deleteCustomLabelOptions($input: DeleteCustomLabelOptionsInput!) {
  deleteCustomLabelOptions(input: $input) {
    ids
  }
}
    `;
export type DeleteCustomLabelOptionsMutationFn = Apollo.MutationFunction<DeleteCustomLabelOptionsMutation, DeleteCustomLabelOptionsMutationVariables>;

/**
 * __useDeleteCustomLabelOptionsMutation__
 *
 * To run a mutation, you first call `useDeleteCustomLabelOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomLabelOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomLabelOptionsMutation, { data, loading, error }] = useDeleteCustomLabelOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomLabelOptionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomLabelOptionsMutation, DeleteCustomLabelOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomLabelOptionsMutation, DeleteCustomLabelOptionsMutationVariables>(DeleteCustomLabelOptionsDocument, options);
      }
export type DeleteCustomLabelOptionsMutationHookResult = ReturnType<typeof useDeleteCustomLabelOptionsMutation>;
export type DeleteCustomLabelOptionsMutationResult = Apollo.MutationResult<DeleteCustomLabelOptionsMutation>;
export type DeleteCustomLabelOptionsMutationOptions = Apollo.BaseMutationOptions<DeleteCustomLabelOptionsMutation, DeleteCustomLabelOptionsMutationVariables>;
export const DeleteTimeSignalDocument = gql`
    mutation deleteTimeSignal($input: DeleteTimeSignalInput!) {
  deleteTimeSignal(input: $input) {
    id
  }
}
    `;
export type DeleteTimeSignalMutationFn = Apollo.MutationFunction<DeleteTimeSignalMutation, DeleteTimeSignalMutationVariables>;

/**
 * __useDeleteTimeSignalMutation__
 *
 * To run a mutation, you first call `useDeleteTimeSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeSignalMutation, { data, loading, error }] = useDeleteTimeSignalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTimeSignalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeSignalMutation, DeleteTimeSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeSignalMutation, DeleteTimeSignalMutationVariables>(DeleteTimeSignalDocument, options);
      }
export type DeleteTimeSignalMutationHookResult = ReturnType<typeof useDeleteTimeSignalMutation>;
export type DeleteTimeSignalMutationResult = Apollo.MutationResult<DeleteTimeSignalMutation>;
export type DeleteTimeSignalMutationOptions = Apollo.BaseMutationOptions<DeleteTimeSignalMutation, DeleteTimeSignalMutationVariables>;
export const DisconnectUserCollectorDocument = gql`
    mutation disconnectUserCollector($input: DisconnectUserCollectorInput!) {
  disconnectUserCollector(input: $input) {
    status
  }
}
    `;
export type DisconnectUserCollectorMutationFn = Apollo.MutationFunction<DisconnectUserCollectorMutation, DisconnectUserCollectorMutationVariables>;

/**
 * __useDisconnectUserCollectorMutation__
 *
 * To run a mutation, you first call `useDisconnectUserCollectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectUserCollectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectUserCollectorMutation, { data, loading, error }] = useDisconnectUserCollectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectUserCollectorMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectUserCollectorMutation, DisconnectUserCollectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectUserCollectorMutation, DisconnectUserCollectorMutationVariables>(DisconnectUserCollectorDocument, options);
      }
export type DisconnectUserCollectorMutationHookResult = ReturnType<typeof useDisconnectUserCollectorMutation>;
export type DisconnectUserCollectorMutationResult = Apollo.MutationResult<DisconnectUserCollectorMutation>;
export type DisconnectUserCollectorMutationOptions = Apollo.BaseMutationOptions<DisconnectUserCollectorMutation, DisconnectUserCollectorMutationVariables>;
export const InstallCollectorDocument = gql`
    mutation installCollector($collectorId: String!) {
  installCollector(collectorId: $collectorId) {
    collectorId
    installId
  }
}
    `;
export type InstallCollectorMutationFn = Apollo.MutationFunction<InstallCollectorMutation, InstallCollectorMutationVariables>;

/**
 * __useInstallCollectorMutation__
 *
 * To run a mutation, you first call `useInstallCollectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallCollectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installCollectorMutation, { data, loading, error }] = useInstallCollectorMutation({
 *   variables: {
 *      collectorId: // value for 'collectorId'
 *   },
 * });
 */
export function useInstallCollectorMutation(baseOptions?: Apollo.MutationHookOptions<InstallCollectorMutation, InstallCollectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InstallCollectorMutation, InstallCollectorMutationVariables>(InstallCollectorDocument, options);
      }
export type InstallCollectorMutationHookResult = ReturnType<typeof useInstallCollectorMutation>;
export type InstallCollectorMutationResult = Apollo.MutationResult<InstallCollectorMutation>;
export type InstallCollectorMutationOptions = Apollo.BaseMutationOptions<InstallCollectorMutation, InstallCollectorMutationVariables>;
export const InstallUserCollectorDocument = gql`
    mutation installUserCollector($collectorId: String!) {
  installUserCollector(collectorId: $collectorId) {
    collectorId
  }
}
    `;
export type InstallUserCollectorMutationFn = Apollo.MutationFunction<InstallUserCollectorMutation, InstallUserCollectorMutationVariables>;

/**
 * __useInstallUserCollectorMutation__
 *
 * To run a mutation, you first call `useInstallUserCollectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallUserCollectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installUserCollectorMutation, { data, loading, error }] = useInstallUserCollectorMutation({
 *   variables: {
 *      collectorId: // value for 'collectorId'
 *   },
 * });
 */
export function useInstallUserCollectorMutation(baseOptions?: Apollo.MutationHookOptions<InstallUserCollectorMutation, InstallUserCollectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InstallUserCollectorMutation, InstallUserCollectorMutationVariables>(InstallUserCollectorDocument, options);
      }
export type InstallUserCollectorMutationHookResult = ReturnType<typeof useInstallUserCollectorMutation>;
export type InstallUserCollectorMutationResult = Apollo.MutationResult<InstallUserCollectorMutation>;
export type InstallUserCollectorMutationOptions = Apollo.BaseMutationOptions<InstallUserCollectorMutation, InstallUserCollectorMutationVariables>;
export const MergeTimeSignalsDocument = gql`
    mutation mergeTimeSignals($input: MergeTimeSignalsInput!) {
  mergeTimeSignals(input: $input) {
    timeSignal {
      ...TimeSignalFragment
    }
    mergedTimeSignals {
      id
    }
  }
}
    ${TimeSignalFragmentFragmentDoc}`;
export type MergeTimeSignalsMutationFn = Apollo.MutationFunction<MergeTimeSignalsMutation, MergeTimeSignalsMutationVariables>;

/**
 * __useMergeTimeSignalsMutation__
 *
 * To run a mutation, you first call `useMergeTimeSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeTimeSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeTimeSignalsMutation, { data, loading, error }] = useMergeTimeSignalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeTimeSignalsMutation(baseOptions?: Apollo.MutationHookOptions<MergeTimeSignalsMutation, MergeTimeSignalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeTimeSignalsMutation, MergeTimeSignalsMutationVariables>(MergeTimeSignalsDocument, options);
      }
export type MergeTimeSignalsMutationHookResult = ReturnType<typeof useMergeTimeSignalsMutation>;
export type MergeTimeSignalsMutationResult = Apollo.MutationResult<MergeTimeSignalsMutation>;
export type MergeTimeSignalsMutationOptions = Apollo.BaseMutationOptions<MergeTimeSignalsMutation, MergeTimeSignalsMutationVariables>;
export const PutAnalyticsMetaDataDocument = gql`
    mutation putAnalyticsMetaData($input: PutAnalyticsMetadataInput!) {
  putAnalyticsMetadata(input: $input) {
    userId
  }
}
    `;
export type PutAnalyticsMetaDataMutationFn = Apollo.MutationFunction<PutAnalyticsMetaDataMutation, PutAnalyticsMetaDataMutationVariables>;

/**
 * __usePutAnalyticsMetaDataMutation__
 *
 * To run a mutation, you first call `usePutAnalyticsMetaDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutAnalyticsMetaDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putAnalyticsMetaDataMutation, { data, loading, error }] = usePutAnalyticsMetaDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePutAnalyticsMetaDataMutation(baseOptions?: Apollo.MutationHookOptions<PutAnalyticsMetaDataMutation, PutAnalyticsMetaDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutAnalyticsMetaDataMutation, PutAnalyticsMetaDataMutationVariables>(PutAnalyticsMetaDataDocument, options);
      }
export type PutAnalyticsMetaDataMutationHookResult = ReturnType<typeof usePutAnalyticsMetaDataMutation>;
export type PutAnalyticsMetaDataMutationResult = Apollo.MutationResult<PutAnalyticsMetaDataMutation>;
export type PutAnalyticsMetaDataMutationOptions = Apollo.BaseMutationOptions<PutAnalyticsMetaDataMutation, PutAnalyticsMetaDataMutationVariables>;
export const PutAutoAcceptSettingsDocument = gql`
    mutation putAutoAcceptSettings($input: PutAutoAcceptSettingInput!) {
  putAutoAcceptSettings(input: $input) {
    id
  }
}
    `;
export type PutAutoAcceptSettingsMutationFn = Apollo.MutationFunction<PutAutoAcceptSettingsMutation, PutAutoAcceptSettingsMutationVariables>;

/**
 * __usePutAutoAcceptSettingsMutation__
 *
 * To run a mutation, you first call `usePutAutoAcceptSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutAutoAcceptSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putAutoAcceptSettingsMutation, { data, loading, error }] = usePutAutoAcceptSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePutAutoAcceptSettingsMutation(baseOptions?: Apollo.MutationHookOptions<PutAutoAcceptSettingsMutation, PutAutoAcceptSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutAutoAcceptSettingsMutation, PutAutoAcceptSettingsMutationVariables>(PutAutoAcceptSettingsDocument, options);
      }
export type PutAutoAcceptSettingsMutationHookResult = ReturnType<typeof usePutAutoAcceptSettingsMutation>;
export type PutAutoAcceptSettingsMutationResult = Apollo.MutationResult<PutAutoAcceptSettingsMutation>;
export type PutAutoAcceptSettingsMutationOptions = Apollo.BaseMutationOptions<PutAutoAcceptSettingsMutation, PutAutoAcceptSettingsMutationVariables>;
export const PutSmartSuggestionSettingsDocument = gql`
    mutation putSmartSuggestionSettings($input: PutSmartSuggestionSettingInput!) {
  putSmartSuggestionSettings(input: $input) {
    id
  }
}
    `;
export type PutSmartSuggestionSettingsMutationFn = Apollo.MutationFunction<PutSmartSuggestionSettingsMutation, PutSmartSuggestionSettingsMutationVariables>;

/**
 * __usePutSmartSuggestionSettingsMutation__
 *
 * To run a mutation, you first call `usePutSmartSuggestionSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutSmartSuggestionSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putSmartSuggestionSettingsMutation, { data, loading, error }] = usePutSmartSuggestionSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePutSmartSuggestionSettingsMutation(baseOptions?: Apollo.MutationHookOptions<PutSmartSuggestionSettingsMutation, PutSmartSuggestionSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutSmartSuggestionSettingsMutation, PutSmartSuggestionSettingsMutationVariables>(PutSmartSuggestionSettingsDocument, options);
      }
export type PutSmartSuggestionSettingsMutationHookResult = ReturnType<typeof usePutSmartSuggestionSettingsMutation>;
export type PutSmartSuggestionSettingsMutationResult = Apollo.MutationResult<PutSmartSuggestionSettingsMutation>;
export type PutSmartSuggestionSettingsMutationOptions = Apollo.BaseMutationOptions<PutSmartSuggestionSettingsMutation, PutSmartSuggestionSettingsMutationVariables>;
export const PutStartEndSettingsDocument = gql`
    mutation putStartEndSettings($input: PutStartEndSettingInput!) {
  putStartEndSettings(input: $input) {
    id
  }
}
    `;
export type PutStartEndSettingsMutationFn = Apollo.MutationFunction<PutStartEndSettingsMutation, PutStartEndSettingsMutationVariables>;

/**
 * __usePutStartEndSettingsMutation__
 *
 * To run a mutation, you first call `usePutStartEndSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutStartEndSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putStartEndSettingsMutation, { data, loading, error }] = usePutStartEndSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePutStartEndSettingsMutation(baseOptions?: Apollo.MutationHookOptions<PutStartEndSettingsMutation, PutStartEndSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutStartEndSettingsMutation, PutStartEndSettingsMutationVariables>(PutStartEndSettingsDocument, options);
      }
export type PutStartEndSettingsMutationHookResult = ReturnType<typeof usePutStartEndSettingsMutation>;
export type PutStartEndSettingsMutationResult = Apollo.MutationResult<PutStartEndSettingsMutation>;
export type PutStartEndSettingsMutationOptions = Apollo.BaseMutationOptions<PutStartEndSettingsMutation, PutStartEndSettingsMutationVariables>;
export const RetryInstallationFlowDocument = gql`
    mutation retryInstallationFlow($input: RetryInstallationFlowInput!) {
  retryInstallationFlow(input: $input) {
    status
  }
}
    `;
export type RetryInstallationFlowMutationFn = Apollo.MutationFunction<RetryInstallationFlowMutation, RetryInstallationFlowMutationVariables>;

/**
 * __useRetryInstallationFlowMutation__
 *
 * To run a mutation, you first call `useRetryInstallationFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryInstallationFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryInstallationFlowMutation, { data, loading, error }] = useRetryInstallationFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryInstallationFlowMutation(baseOptions?: Apollo.MutationHookOptions<RetryInstallationFlowMutation, RetryInstallationFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryInstallationFlowMutation, RetryInstallationFlowMutationVariables>(RetryInstallationFlowDocument, options);
      }
export type RetryInstallationFlowMutationHookResult = ReturnType<typeof useRetryInstallationFlowMutation>;
export type RetryInstallationFlowMutationResult = Apollo.MutationResult<RetryInstallationFlowMutation>;
export type RetryInstallationFlowMutationOptions = Apollo.BaseMutationOptions<RetryInstallationFlowMutation, RetryInstallationFlowMutationVariables>;
export const SplitTimeSingalDocument = gql`
    mutation splitTimeSingal($input: SplitTimeSignalInput!) {
  splitTimeSignal(input: $input) {
    timeSignals {
      ...TimeSignalFragment
    }
  }
}
    ${TimeSignalFragmentFragmentDoc}`;
export type SplitTimeSingalMutationFn = Apollo.MutationFunction<SplitTimeSingalMutation, SplitTimeSingalMutationVariables>;

/**
 * __useSplitTimeSingalMutation__
 *
 * To run a mutation, you first call `useSplitTimeSingalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitTimeSingalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitTimeSingalMutation, { data, loading, error }] = useSplitTimeSingalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSplitTimeSingalMutation(baseOptions?: Apollo.MutationHookOptions<SplitTimeSingalMutation, SplitTimeSingalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitTimeSingalMutation, SplitTimeSingalMutationVariables>(SplitTimeSingalDocument, options);
      }
export type SplitTimeSingalMutationHookResult = ReturnType<typeof useSplitTimeSingalMutation>;
export type SplitTimeSingalMutationResult = Apollo.MutationResult<SplitTimeSingalMutation>;
export type SplitTimeSingalMutationOptions = Apollo.BaseMutationOptions<SplitTimeSingalMutation, SplitTimeSingalMutationVariables>;
export const SyncDiaryToTimesheetDocument = gql`
    mutation syncDiaryToTimesheet($input: SyncDiaryToTimesheetInput!) {
  syncDiaryToTimesheet(input: $input) {
    result {
      entries {
        entry {
          id
        }
        error {
          ...DiaryErrorFragment
        }
      }
    }
    error {
      ...DiaryErrorFragment
    }
  }
}
    ${DiaryErrorFragmentFragmentDoc}`;
export type SyncDiaryToTimesheetMutationFn = Apollo.MutationFunction<SyncDiaryToTimesheetMutation, SyncDiaryToTimesheetMutationVariables>;

/**
 * __useSyncDiaryToTimesheetMutation__
 *
 * To run a mutation, you first call `useSyncDiaryToTimesheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDiaryToTimesheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDiaryToTimesheetMutation, { data, loading, error }] = useSyncDiaryToTimesheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDiaryToTimesheetMutation(baseOptions?: Apollo.MutationHookOptions<SyncDiaryToTimesheetMutation, SyncDiaryToTimesheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDiaryToTimesheetMutation, SyncDiaryToTimesheetMutationVariables>(SyncDiaryToTimesheetDocument, options);
      }
export type SyncDiaryToTimesheetMutationHookResult = ReturnType<typeof useSyncDiaryToTimesheetMutation>;
export type SyncDiaryToTimesheetMutationResult = Apollo.MutationResult<SyncDiaryToTimesheetMutation>;
export type SyncDiaryToTimesheetMutationOptions = Apollo.BaseMutationOptions<SyncDiaryToTimesheetMutation, SyncDiaryToTimesheetMutationVariables>;
export const TrainLabelSuggestionsDocument = gql`
    mutation trainLabelSuggestions($user: String!) {
  trainLabelSuggestions(user: $user) {
    user
  }
}
    `;
export type TrainLabelSuggestionsMutationFn = Apollo.MutationFunction<TrainLabelSuggestionsMutation, TrainLabelSuggestionsMutationVariables>;

/**
 * __useTrainLabelSuggestionsMutation__
 *
 * To run a mutation, you first call `useTrainLabelSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainLabelSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainLabelSuggestionsMutation, { data, loading, error }] = useTrainLabelSuggestionsMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useTrainLabelSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<TrainLabelSuggestionsMutation, TrainLabelSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainLabelSuggestionsMutation, TrainLabelSuggestionsMutationVariables>(TrainLabelSuggestionsDocument, options);
      }
export type TrainLabelSuggestionsMutationHookResult = ReturnType<typeof useTrainLabelSuggestionsMutation>;
export type TrainLabelSuggestionsMutationResult = Apollo.MutationResult<TrainLabelSuggestionsMutation>;
export type TrainLabelSuggestionsMutationOptions = Apollo.BaseMutationOptions<TrainLabelSuggestionsMutation, TrainLabelSuggestionsMutationVariables>;
export const UninstallCollectorDocument = gql`
    mutation uninstallCollector($collectorId: String!) {
  uninstallCollector(collectorId: $collectorId) {
    collectorId
  }
}
    `;
export type UninstallCollectorMutationFn = Apollo.MutationFunction<UninstallCollectorMutation, UninstallCollectorMutationVariables>;

/**
 * __useUninstallCollectorMutation__
 *
 * To run a mutation, you first call `useUninstallCollectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUninstallCollectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uninstallCollectorMutation, { data, loading, error }] = useUninstallCollectorMutation({
 *   variables: {
 *      collectorId: // value for 'collectorId'
 *   },
 * });
 */
export function useUninstallCollectorMutation(baseOptions?: Apollo.MutationHookOptions<UninstallCollectorMutation, UninstallCollectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UninstallCollectorMutation, UninstallCollectorMutationVariables>(UninstallCollectorDocument, options);
      }
export type UninstallCollectorMutationHookResult = ReturnType<typeof useUninstallCollectorMutation>;
export type UninstallCollectorMutationResult = Apollo.MutationResult<UninstallCollectorMutation>;
export type UninstallCollectorMutationOptions = Apollo.BaseMutationOptions<UninstallCollectorMutation, UninstallCollectorMutationVariables>;
export const UninstallUserCollectorDocument = gql`
    mutation uninstallUserCollector($collectorId: String!) {
  uninstallUserCollector(collectorId: $collectorId) {
    collectorId
  }
}
    `;
export type UninstallUserCollectorMutationFn = Apollo.MutationFunction<UninstallUserCollectorMutation, UninstallUserCollectorMutationVariables>;

/**
 * __useUninstallUserCollectorMutation__
 *
 * To run a mutation, you first call `useUninstallUserCollectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUninstallUserCollectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uninstallUserCollectorMutation, { data, loading, error }] = useUninstallUserCollectorMutation({
 *   variables: {
 *      collectorId: // value for 'collectorId'
 *   },
 * });
 */
export function useUninstallUserCollectorMutation(baseOptions?: Apollo.MutationHookOptions<UninstallUserCollectorMutation, UninstallUserCollectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UninstallUserCollectorMutation, UninstallUserCollectorMutationVariables>(UninstallUserCollectorDocument, options);
      }
export type UninstallUserCollectorMutationHookResult = ReturnType<typeof useUninstallUserCollectorMutation>;
export type UninstallUserCollectorMutationResult = Apollo.MutationResult<UninstallUserCollectorMutation>;
export type UninstallUserCollectorMutationOptions = Apollo.BaseMutationOptions<UninstallUserCollectorMutation, UninstallUserCollectorMutationVariables>;
export const UpdateCustomLabelDocument = gql`
    mutation updateCustomLabel($input: UpdateCustomLabelInput!) {
  updateCustomLabel(input: $input) {
    customLabel {
      id
      type
      name
      origin
    }
  }
}
    `;
export type UpdateCustomLabelMutationFn = Apollo.MutationFunction<UpdateCustomLabelMutation, UpdateCustomLabelMutationVariables>;

/**
 * __useUpdateCustomLabelMutation__
 *
 * To run a mutation, you first call `useUpdateCustomLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomLabelMutation, { data, loading, error }] = useUpdateCustomLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomLabelMutation, UpdateCustomLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomLabelMutation, UpdateCustomLabelMutationVariables>(UpdateCustomLabelDocument, options);
      }
export type UpdateCustomLabelMutationHookResult = ReturnType<typeof useUpdateCustomLabelMutation>;
export type UpdateCustomLabelMutationResult = Apollo.MutationResult<UpdateCustomLabelMutation>;
export type UpdateCustomLabelMutationOptions = Apollo.BaseMutationOptions<UpdateCustomLabelMutation, UpdateCustomLabelMutationVariables>;
export const UpdateCustomLabelOptionsDocument = gql`
    mutation updateCustomLabelOptions($input: UpdateCustomLabelOptionsInput!) {
  updateCustomLabelOptions(input: $input) {
    customLabelOptions {
      id
      name
    }
  }
}
    `;
export type UpdateCustomLabelOptionsMutationFn = Apollo.MutationFunction<UpdateCustomLabelOptionsMutation, UpdateCustomLabelOptionsMutationVariables>;

/**
 * __useUpdateCustomLabelOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomLabelOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomLabelOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomLabelOptionsMutation, { data, loading, error }] = useUpdateCustomLabelOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomLabelOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomLabelOptionsMutation, UpdateCustomLabelOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomLabelOptionsMutation, UpdateCustomLabelOptionsMutationVariables>(UpdateCustomLabelOptionsDocument, options);
      }
export type UpdateCustomLabelOptionsMutationHookResult = ReturnType<typeof useUpdateCustomLabelOptionsMutation>;
export type UpdateCustomLabelOptionsMutationResult = Apollo.MutationResult<UpdateCustomLabelOptionsMutation>;
export type UpdateCustomLabelOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateCustomLabelOptionsMutation, UpdateCustomLabelOptionsMutationVariables>;
export const UpdateSettingPreferencesForCollectorSettingDocument = gql`
    mutation updateSettingPreferencesForCollectorSetting($input: UpdateSettingPreferencesForCollectorSettingInput!) {
  updateSettingPreferencesForCollectorSetting(input: $input) {
    installId
  }
}
    `;
export type UpdateSettingPreferencesForCollectorSettingMutationFn = Apollo.MutationFunction<UpdateSettingPreferencesForCollectorSettingMutation, UpdateSettingPreferencesForCollectorSettingMutationVariables>;

/**
 * __useUpdateSettingPreferencesForCollectorSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSettingPreferencesForCollectorSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingPreferencesForCollectorSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingPreferencesForCollectorSettingMutation, { data, loading, error }] = useUpdateSettingPreferencesForCollectorSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingPreferencesForCollectorSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingPreferencesForCollectorSettingMutation, UpdateSettingPreferencesForCollectorSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingPreferencesForCollectorSettingMutation, UpdateSettingPreferencesForCollectorSettingMutationVariables>(UpdateSettingPreferencesForCollectorSettingDocument, options);
      }
export type UpdateSettingPreferencesForCollectorSettingMutationHookResult = ReturnType<typeof useUpdateSettingPreferencesForCollectorSettingMutation>;
export type UpdateSettingPreferencesForCollectorSettingMutationResult = Apollo.MutationResult<UpdateSettingPreferencesForCollectorSettingMutation>;
export type UpdateSettingPreferencesForCollectorSettingMutationOptions = Apollo.BaseMutationOptions<UpdateSettingPreferencesForCollectorSettingMutation, UpdateSettingPreferencesForCollectorSettingMutationVariables>;
export const UpdateTimeSignalDocument = gql`
    mutation updateTimeSignal($input: UpdateTimeSignalInput!) {
  updateTimeSignal(input: $input) {
    timeSignal {
      ...TimeSignalFragment
    }
  }
}
    ${TimeSignalFragmentFragmentDoc}`;
export type UpdateTimeSignalMutationFn = Apollo.MutationFunction<UpdateTimeSignalMutation, UpdateTimeSignalMutationVariables>;

/**
 * __useUpdateTimeSignalMutation__
 *
 * To run a mutation, you first call `useUpdateTimeSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeSignalMutation, { data, loading, error }] = useUpdateTimeSignalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeSignalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeSignalMutation, UpdateTimeSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeSignalMutation, UpdateTimeSignalMutationVariables>(UpdateTimeSignalDocument, options);
      }
export type UpdateTimeSignalMutationHookResult = ReturnType<typeof useUpdateTimeSignalMutation>;
export type UpdateTimeSignalMutationResult = Apollo.MutationResult<UpdateTimeSignalMutation>;
export type UpdateTimeSignalMutationOptions = Apollo.BaseMutationOptions<UpdateTimeSignalMutation, UpdateTimeSignalMutationVariables>;
export const UpdateUserPreferenceForTenantCollectorSettingDocument = gql`
    mutation updateUserPreferenceForTenantCollectorSetting($input: UpdateUserPreferenceForTenantCollectorSettingInput!) {
  updateUserPreferenceForTenantCollectorSetting(input: $input) {
    installId
  }
}
    `;
export type UpdateUserPreferenceForTenantCollectorSettingMutationFn = Apollo.MutationFunction<UpdateUserPreferenceForTenantCollectorSettingMutation, UpdateUserPreferenceForTenantCollectorSettingMutationVariables>;

/**
 * __useUpdateUserPreferenceForTenantCollectorSettingMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceForTenantCollectorSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceForTenantCollectorSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceForTenantCollectorSettingMutation, { data, loading, error }] = useUpdateUserPreferenceForTenantCollectorSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPreferenceForTenantCollectorSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferenceForTenantCollectorSettingMutation, UpdateUserPreferenceForTenantCollectorSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferenceForTenantCollectorSettingMutation, UpdateUserPreferenceForTenantCollectorSettingMutationVariables>(UpdateUserPreferenceForTenantCollectorSettingDocument, options);
      }
export type UpdateUserPreferenceForTenantCollectorSettingMutationHookResult = ReturnType<typeof useUpdateUserPreferenceForTenantCollectorSettingMutation>;
export type UpdateUserPreferenceForTenantCollectorSettingMutationResult = Apollo.MutationResult<UpdateUserPreferenceForTenantCollectorSettingMutation>;
export type UpdateUserPreferenceForTenantCollectorSettingMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferenceForTenantCollectorSettingMutation, UpdateUserPreferenceForTenantCollectorSettingMutationVariables>;
export const ActivityLabelOptionsDocument = gql`
    query activityLabelOptions($date: Date!, $input: TimesheetLabelValueSearchInput) {
  timesheetLabelValueSearch(date: $date) {
    activities(input: $input) {
      items {
        id
        name
      }
      cursor
      totalCount
    }
  }
}
    `;

/**
 * __useActivityLabelOptionsQuery__
 *
 * To run a query within a React component, call `useActivityLabelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLabelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLabelOptionsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityLabelOptionsQuery(baseOptions: Apollo.QueryHookOptions<ActivityLabelOptionsQuery, ActivityLabelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLabelOptionsQuery, ActivityLabelOptionsQueryVariables>(ActivityLabelOptionsDocument, options);
      }
export function useActivityLabelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLabelOptionsQuery, ActivityLabelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLabelOptionsQuery, ActivityLabelOptionsQueryVariables>(ActivityLabelOptionsDocument, options);
        }
export type ActivityLabelOptionsQueryHookResult = ReturnType<typeof useActivityLabelOptionsQuery>;
export type ActivityLabelOptionsLazyQueryHookResult = ReturnType<typeof useActivityLabelOptionsLazyQuery>;
export type ActivityLabelOptionsQueryResult = Apollo.QueryResult<ActivityLabelOptionsQuery, ActivityLabelOptionsQueryVariables>;
export const AllCollectorsDocument = gql`
    query allCollectors($input: CollectorInput) {
  collectors(input: $input) {
    items {
      id
      name
      type
      publishedBy
      category
      retryURL
      configURL
      description
      installURL
      uninstallURL
      userInstallURL
      userUninstallURL
      appScope
      image {
        src
      }
      installations {
        items {
          scope
          installId
        }
      }
    }
  }
}
    `;

/**
 * __useAllCollectorsQuery__
 *
 * To run a query within a React component, call `useAllCollectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCollectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCollectorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllCollectorsQuery(baseOptions?: Apollo.QueryHookOptions<AllCollectorsQuery, AllCollectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCollectorsQuery, AllCollectorsQueryVariables>(AllCollectorsDocument, options);
      }
export function useAllCollectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCollectorsQuery, AllCollectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCollectorsQuery, AllCollectorsQueryVariables>(AllCollectorsDocument, options);
        }
export type AllCollectorsQueryHookResult = ReturnType<typeof useAllCollectorsQuery>;
export type AllCollectorsLazyQueryHookResult = ReturnType<typeof useAllCollectorsLazyQuery>;
export type AllCollectorsQueryResult = Apollo.QueryResult<AllCollectorsQuery, AllCollectorsQueryVariables>;
export const AnalyticsMetaDataDocument = gql`
    query analyticsMetaData($input: AnalyticsMetadataInput) {
  analyticsMetadata(input: $input) {
    metadata {
      id
      name
    }
  }
}
    `;

/**
 * __useAnalyticsMetaDataQuery__
 *
 * To run a query within a React component, call `useAnalyticsMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMetaDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyticsMetaDataQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsMetaDataQuery, AnalyticsMetaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsMetaDataQuery, AnalyticsMetaDataQueryVariables>(AnalyticsMetaDataDocument, options);
      }
export function useAnalyticsMetaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsMetaDataQuery, AnalyticsMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsMetaDataQuery, AnalyticsMetaDataQueryVariables>(AnalyticsMetaDataDocument, options);
        }
export type AnalyticsMetaDataQueryHookResult = ReturnType<typeof useAnalyticsMetaDataQuery>;
export type AnalyticsMetaDataLazyQueryHookResult = ReturnType<typeof useAnalyticsMetaDataLazyQuery>;
export type AnalyticsMetaDataQueryResult = Apollo.QueryResult<AnalyticsMetaDataQuery, AnalyticsMetaDataQueryVariables>;
export const GetAutoAcceptSettingsDocument = gql`
    query getAutoAcceptSettings {
  getAutoAcceptSettings {
    enabled
  }
}
    `;

/**
 * __useGetAutoAcceptSettingsQuery__
 *
 * To run a query within a React component, call `useGetAutoAcceptSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoAcceptSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoAcceptSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoAcceptSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAutoAcceptSettingsQuery, GetAutoAcceptSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutoAcceptSettingsQuery, GetAutoAcceptSettingsQueryVariables>(GetAutoAcceptSettingsDocument, options);
      }
export function useGetAutoAcceptSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutoAcceptSettingsQuery, GetAutoAcceptSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutoAcceptSettingsQuery, GetAutoAcceptSettingsQueryVariables>(GetAutoAcceptSettingsDocument, options);
        }
export type GetAutoAcceptSettingsQueryHookResult = ReturnType<typeof useGetAutoAcceptSettingsQuery>;
export type GetAutoAcceptSettingsLazyQueryHookResult = ReturnType<typeof useGetAutoAcceptSettingsLazyQuery>;
export type GetAutoAcceptSettingsQueryResult = Apollo.QueryResult<GetAutoAcceptSettingsQuery, GetAutoAcceptSettingsQueryVariables>;
export const BillingLabelOptionsDocument = gql`
    query billingLabelOptions($date: Date!, $input: TimesheetBillingRateValueSearchInput) {
  timesheetLabelValueSearch(date: $date) {
    billingRates(input: $input) {
      items {
        id
        name
      }
      cursor
      totalCount
    }
  }
}
    `;

/**
 * __useBillingLabelOptionsQuery__
 *
 * To run a query within a React component, call `useBillingLabelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingLabelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingLabelOptionsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingLabelOptionsQuery(baseOptions: Apollo.QueryHookOptions<BillingLabelOptionsQuery, BillingLabelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingLabelOptionsQuery, BillingLabelOptionsQueryVariables>(BillingLabelOptionsDocument, options);
      }
export function useBillingLabelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingLabelOptionsQuery, BillingLabelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingLabelOptionsQuery, BillingLabelOptionsQueryVariables>(BillingLabelOptionsDocument, options);
        }
export type BillingLabelOptionsQueryHookResult = ReturnType<typeof useBillingLabelOptionsQuery>;
export type BillingLabelOptionsLazyQueryHookResult = ReturnType<typeof useBillingLabelOptionsLazyQuery>;
export type BillingLabelOptionsQueryResult = Apollo.QueryResult<BillingLabelOptionsQuery, BillingLabelOptionsQueryVariables>;
export const CollectorDocument = gql`
    query collector($input: String!) {
  collector(id: $input) {
    item {
      id
      name
      retryURL
      configURL
      installURL
      uninstallURL
      userInstallURL
      userUninstallURL
      image {
        src
      }
    }
  }
}
    `;

/**
 * __useCollectorQuery__
 *
 * To run a query within a React component, call `useCollectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectorQuery(baseOptions: Apollo.QueryHookOptions<CollectorQuery, CollectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectorQuery, CollectorQueryVariables>(CollectorDocument, options);
      }
export function useCollectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectorQuery, CollectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectorQuery, CollectorQueryVariables>(CollectorDocument, options);
        }
export type CollectorQueryHookResult = ReturnType<typeof useCollectorQuery>;
export type CollectorLazyQueryHookResult = ReturnType<typeof useCollectorLazyQuery>;
export type CollectorQueryResult = Apollo.QueryResult<CollectorQuery, CollectorQueryVariables>;
export const CollectorSettingDocument = gql`
    query collectorSetting($input: CollectorSettingInput!) {
  collectorSetting(input: $input) {
    item {
      installId
      collectorId
      settings {
        key
        value
      }
      installStatus {
        errors {
          errorId
          title
          message
          date
        }
      }
      installedDate
      maintainers {
        displayText
        userId
      }
      groupSettings {
        enabled
        canOptOut
        accessScopeIn {
          locations {
            id
            name
          }
          divisions {
            id
            name
          }
          costCenters {
            id
            name
          }
          serviceCenters {
            id
            name
          }
          departments {
            id
            name
          }
          employeeTypes {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCollectorSettingQuery__
 *
 * To run a query within a React component, call `useCollectorSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectorSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectorSettingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectorSettingQuery(baseOptions: Apollo.QueryHookOptions<CollectorSettingQuery, CollectorSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectorSettingQuery, CollectorSettingQueryVariables>(CollectorSettingDocument, options);
      }
export function useCollectorSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectorSettingQuery, CollectorSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectorSettingQuery, CollectorSettingQueryVariables>(CollectorSettingDocument, options);
        }
export type CollectorSettingQueryHookResult = ReturnType<typeof useCollectorSettingQuery>;
export type CollectorSettingLazyQueryHookResult = ReturnType<typeof useCollectorSettingLazyQuery>;
export type CollectorSettingQueryResult = Apollo.QueryResult<CollectorSettingQuery, CollectorSettingQueryVariables>;
export const CollectorSettingsDocument = gql`
    query collectorSettings($input: CollectorSettingsInput) {
  collectorSettings(input: $input) {
    items {
      installId
      collectorId
      installedDate
      settings {
        key
        value
      }
      installStatus {
        errors {
          message
        }
      }
      collectorMetadata {
        name
        type
        retryURL
      }
    }
  }
}
    `;

/**
 * __useCollectorSettingsQuery__
 *
 * To run a query within a React component, call `useCollectorSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectorSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectorSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectorSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CollectorSettingsQuery, CollectorSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectorSettingsQuery, CollectorSettingsQueryVariables>(CollectorSettingsDocument, options);
      }
export function useCollectorSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectorSettingsQuery, CollectorSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectorSettingsQuery, CollectorSettingsQueryVariables>(CollectorSettingsDocument, options);
        }
export type CollectorSettingsQueryHookResult = ReturnType<typeof useCollectorSettingsQuery>;
export type CollectorSettingsLazyQueryHookResult = ReturnType<typeof useCollectorSettingsLazyQuery>;
export type CollectorSettingsQueryResult = Apollo.QueryResult<CollectorSettingsQuery, CollectorSettingsQueryVariables>;
export const CollectorSettingsUnifiedDocument = gql`
    query collectorSettingsUnified($input: CollectorSettingsInput) {
  collectorSettings(input: $input) {
    items {
      collectorId
      scope
      installedDate
      settings {
        key
        value
      }
      installStatus {
        errors {
          message
        }
      }
      maintainers {
        displayText
        userId
      }
    }
  }
}
    `;

/**
 * __useCollectorSettingsUnifiedQuery__
 *
 * To run a query within a React component, call `useCollectorSettingsUnifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectorSettingsUnifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectorSettingsUnifiedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectorSettingsUnifiedQuery(baseOptions?: Apollo.QueryHookOptions<CollectorSettingsUnifiedQuery, CollectorSettingsUnifiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectorSettingsUnifiedQuery, CollectorSettingsUnifiedQueryVariables>(CollectorSettingsUnifiedDocument, options);
      }
export function useCollectorSettingsUnifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectorSettingsUnifiedQuery, CollectorSettingsUnifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectorSettingsUnifiedQuery, CollectorSettingsUnifiedQueryVariables>(CollectorSettingsUnifiedDocument, options);
        }
export type CollectorSettingsUnifiedQueryHookResult = ReturnType<typeof useCollectorSettingsUnifiedQuery>;
export type CollectorSettingsUnifiedLazyQueryHookResult = ReturnType<typeof useCollectorSettingsUnifiedLazyQuery>;
export type CollectorSettingsUnifiedQueryResult = Apollo.QueryResult<CollectorSettingsUnifiedQuery, CollectorSettingsUnifiedQueryVariables>;
export const CollectorsDocument = gql`
    query collectors {
  collectors {
    items {
      id
      name
      type
      publishedBy
      category
      retryURL
      installURL
      uninstallURL
      appScope
      image {
        src
      }
    }
  }
}
    `;

/**
 * __useCollectorsQuery__
 *
 * To run a query within a React component, call `useCollectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollectorsQuery(baseOptions?: Apollo.QueryHookOptions<CollectorsQuery, CollectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectorsQuery, CollectorsQueryVariables>(CollectorsDocument, options);
      }
export function useCollectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectorsQuery, CollectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectorsQuery, CollectorsQueryVariables>(CollectorsDocument, options);
        }
export type CollectorsQueryHookResult = ReturnType<typeof useCollectorsQuery>;
export type CollectorsLazyQueryHookResult = ReturnType<typeof useCollectorsLazyQuery>;
export type CollectorsQueryResult = Apollo.QueryResult<CollectorsQuery, CollectorsQueryVariables>;
export const CompanyCollectorsDocument = gql`
    query companyCollectors($input: CollectorInput) {
  collectors(input: $input) {
    items {
      id
      name
      type
      publishedBy
      category
      retryURL
      installURL
      uninstallURL
      image {
        src
      }
    }
  }
}
    `;

/**
 * __useCompanyCollectorsQuery__
 *
 * To run a query within a React component, call `useCompanyCollectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyCollectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyCollectorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyCollectorsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyCollectorsQuery, CompanyCollectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyCollectorsQuery, CompanyCollectorsQueryVariables>(CompanyCollectorsDocument, options);
      }
export function useCompanyCollectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyCollectorsQuery, CompanyCollectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyCollectorsQuery, CompanyCollectorsQueryVariables>(CompanyCollectorsDocument, options);
        }
export type CompanyCollectorsQueryHookResult = ReturnType<typeof useCompanyCollectorsQuery>;
export type CompanyCollectorsLazyQueryHookResult = ReturnType<typeof useCompanyCollectorsLazyQuery>;
export type CompanyCollectorsQueryResult = Apollo.QueryResult<CompanyCollectorsQuery, CompanyCollectorsQueryVariables>;
export const DiaryDocument = gql`
    query diary($date: Date!) {
  diary(date: $date) {
    ...DiaryFragment
  }
}
    ${DiaryFragmentFragmentDoc}`;

/**
 * __useDiaryQuery__
 *
 * To run a query within a React component, call `useDiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiaryQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useDiaryQuery(baseOptions: Apollo.QueryHookOptions<DiaryQuery, DiaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiaryQuery, DiaryQueryVariables>(DiaryDocument, options);
      }
export function useDiaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiaryQuery, DiaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiaryQuery, DiaryQueryVariables>(DiaryDocument, options);
        }
export type DiaryQueryHookResult = ReturnType<typeof useDiaryQuery>;
export type DiaryLazyQueryHookResult = ReturnType<typeof useDiaryLazyQuery>;
export type DiaryQueryResult = Apollo.QueryResult<DiaryQuery, DiaryQueryVariables>;
export const DataSciencePerformanceAnalyticsDocument = gql`
    query dataSciencePerformanceAnalytics {
  dataSciencePerformanceAnalytics {
    overallAccuracy
  }
}
    `;

/**
 * __useDataSciencePerformanceAnalyticsQuery__
 *
 * To run a query within a React component, call `useDataSciencePerformanceAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSciencePerformanceAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSciencePerformanceAnalyticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataSciencePerformanceAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<DataSciencePerformanceAnalyticsQuery, DataSciencePerformanceAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSciencePerformanceAnalyticsQuery, DataSciencePerformanceAnalyticsQueryVariables>(DataSciencePerformanceAnalyticsDocument, options);
      }
export function useDataSciencePerformanceAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSciencePerformanceAnalyticsQuery, DataSciencePerformanceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSciencePerformanceAnalyticsQuery, DataSciencePerformanceAnalyticsQueryVariables>(DataSciencePerformanceAnalyticsDocument, options);
        }
export type DataSciencePerformanceAnalyticsQueryHookResult = ReturnType<typeof useDataSciencePerformanceAnalyticsQuery>;
export type DataSciencePerformanceAnalyticsLazyQueryHookResult = ReturnType<typeof useDataSciencePerformanceAnalyticsLazyQuery>;
export type DataSciencePerformanceAnalyticsQueryResult = Apollo.QueryResult<DataSciencePerformanceAnalyticsQuery, DataSciencePerformanceAnalyticsQueryVariables>;
export const DefaultBillingRateDocument = gql`
    query defaultBillingRate($date: Date!, $input: DefaultBillingRateInput) {
  timesheetLabelValueSearch(date: $date) {
    defaultBillingRate(input: $input) {
      item {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDefaultBillingRateQuery__
 *
 * To run a query within a React component, call `useDefaultBillingRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultBillingRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultBillingRateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefaultBillingRateQuery(baseOptions: Apollo.QueryHookOptions<DefaultBillingRateQuery, DefaultBillingRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultBillingRateQuery, DefaultBillingRateQueryVariables>(DefaultBillingRateDocument, options);
      }
export function useDefaultBillingRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultBillingRateQuery, DefaultBillingRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultBillingRateQuery, DefaultBillingRateQueryVariables>(DefaultBillingRateDocument, options);
        }
export type DefaultBillingRateQueryHookResult = ReturnType<typeof useDefaultBillingRateQuery>;
export type DefaultBillingRateLazyQueryHookResult = ReturnType<typeof useDefaultBillingRateLazyQuery>;
export type DefaultBillingRateQueryResult = Apollo.QueryResult<DefaultBillingRateQuery, DefaultBillingRateQueryVariables>;
export const DiariesForDateRangeDocument = gql`
    query diariesForDateRange($dateRange: DateRangeInput!) {
  diariesForDateRange(dateRange: $dateRange) {
    diaries {
      ...DiaryFragment
    }
  }
}
    ${DiaryFragmentFragmentDoc}`;

/**
 * __useDiariesForDateRangeQuery__
 *
 * To run a query within a React component, call `useDiariesForDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiariesForDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiariesForDateRangeQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useDiariesForDateRangeQuery(baseOptions: Apollo.QueryHookOptions<DiariesForDateRangeQuery, DiariesForDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiariesForDateRangeQuery, DiariesForDateRangeQueryVariables>(DiariesForDateRangeDocument, options);
      }
export function useDiariesForDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiariesForDateRangeQuery, DiariesForDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiariesForDateRangeQuery, DiariesForDateRangeQueryVariables>(DiariesForDateRangeDocument, options);
        }
export type DiariesForDateRangeQueryHookResult = ReturnType<typeof useDiariesForDateRangeQuery>;
export type DiariesForDateRangeLazyQueryHookResult = ReturnType<typeof useDiariesForDateRangeLazyQuery>;
export type DiariesForDateRangeQueryResult = Apollo.QueryResult<DiariesForDateRangeQuery, DiariesForDateRangeQueryVariables>;
export const EnabledGroupTypesDocument = gql`
    query enabledGroupTypes {
  enabledGroupTypes {
    items {
      value
    }
  }
}
    `;

/**
 * __useEnabledGroupTypesQuery__
 *
 * To run a query within a React component, call `useEnabledGroupTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledGroupTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledGroupTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledGroupTypesQuery(baseOptions?: Apollo.QueryHookOptions<EnabledGroupTypesQuery, EnabledGroupTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnabledGroupTypesQuery, EnabledGroupTypesQueryVariables>(EnabledGroupTypesDocument, options);
      }
export function useEnabledGroupTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnabledGroupTypesQuery, EnabledGroupTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnabledGroupTypesQuery, EnabledGroupTypesQueryVariables>(EnabledGroupTypesDocument, options);
        }
export type EnabledGroupTypesQueryHookResult = ReturnType<typeof useEnabledGroupTypesQuery>;
export type EnabledGroupTypesLazyQueryHookResult = ReturnType<typeof useEnabledGroupTypesLazyQuery>;
export type EnabledGroupTypesQueryResult = Apollo.QueryResult<EnabledGroupTypesQuery, EnabledGroupTypesQueryVariables>;
export const CostCentersDocument = gql`
    query costCenters($input: GroupSearchInput) {
  groupsSearch {
    costCenters(input: $input) {
      items {
        id
        displayText
        level
      }
    }
  }
}
    `;

/**
 * __useCostCentersQuery__
 *
 * To run a query within a React component, call `useCostCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCentersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCostCentersQuery(baseOptions?: Apollo.QueryHookOptions<CostCentersQuery, CostCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostCentersQuery, CostCentersQueryVariables>(CostCentersDocument, options);
      }
export function useCostCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostCentersQuery, CostCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostCentersQuery, CostCentersQueryVariables>(CostCentersDocument, options);
        }
export type CostCentersQueryHookResult = ReturnType<typeof useCostCentersQuery>;
export type CostCentersLazyQueryHookResult = ReturnType<typeof useCostCentersLazyQuery>;
export type CostCentersQueryResult = Apollo.QueryResult<CostCentersQuery, CostCentersQueryVariables>;
export const DepartmentsDocument = gql`
    query departments($input: GroupSearchInput) {
  groupsSearch {
    departments(input: $input) {
      items {
        id
        displayText
        level
      }
    }
  }
}
    `;

/**
 * __useDepartmentsQuery__
 *
 * To run a query within a React component, call `useDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
      }
export function useDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
export type DepartmentsQueryHookResult = ReturnType<typeof useDepartmentsQuery>;
export type DepartmentsLazyQueryHookResult = ReturnType<typeof useDepartmentsLazyQuery>;
export type DepartmentsQueryResult = Apollo.QueryResult<DepartmentsQuery, DepartmentsQueryVariables>;
export const DivisionsDocument = gql`
    query divisions($input: GroupSearchInput) {
  groupsSearch {
    divisions(input: $input) {
      items {
        id
        displayText
        level
      }
    }
  }
}
    `;

/**
 * __useDivisionsQuery__
 *
 * To run a query within a React component, call `useDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDivisionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDivisionsQuery(baseOptions?: Apollo.QueryHookOptions<DivisionsQuery, DivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DivisionsQuery, DivisionsQueryVariables>(DivisionsDocument, options);
      }
export function useDivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DivisionsQuery, DivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DivisionsQuery, DivisionsQueryVariables>(DivisionsDocument, options);
        }
export type DivisionsQueryHookResult = ReturnType<typeof useDivisionsQuery>;
export type DivisionsLazyQueryHookResult = ReturnType<typeof useDivisionsLazyQuery>;
export type DivisionsQueryResult = Apollo.QueryResult<DivisionsQuery, DivisionsQueryVariables>;
export const EmployeeTypesDocument = gql`
    query employeeTypes($input: GroupSearchInput) {
  groupsSearch {
    employeeTypes(input: $input) {
      items {
        id
        displayText
        level
      }
    }
  }
}
    `;

/**
 * __useEmployeeTypesQuery__
 *
 * To run a query within a React component, call `useEmployeeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeTypesQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeTypesQuery, EmployeeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeTypesQuery, EmployeeTypesQueryVariables>(EmployeeTypesDocument, options);
      }
export function useEmployeeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeTypesQuery, EmployeeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeTypesQuery, EmployeeTypesQueryVariables>(EmployeeTypesDocument, options);
        }
export type EmployeeTypesQueryHookResult = ReturnType<typeof useEmployeeTypesQuery>;
export type EmployeeTypesLazyQueryHookResult = ReturnType<typeof useEmployeeTypesLazyQuery>;
export type EmployeeTypesQueryResult = Apollo.QueryResult<EmployeeTypesQuery, EmployeeTypesQueryVariables>;
export const LocationsDocument = gql`
    query locations($input: GroupSearchInput) {
  groupsSearch {
    locations(input: $input) {
      items {
        id
        displayText
        level
      }
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const ServiceCentersDocument = gql`
    query serviceCenters($input: GroupSearchInput) {
  groupsSearch {
    serviceCenters(input: $input) {
      items {
        id
        displayText
        level
      }
    }
  }
}
    `;

/**
 * __useServiceCentersQuery__
 *
 * To run a query within a React component, call `useServiceCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCentersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServiceCentersQuery(baseOptions?: Apollo.QueryHookOptions<ServiceCentersQuery, ServiceCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceCentersQuery, ServiceCentersQueryVariables>(ServiceCentersDocument, options);
      }
export function useServiceCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceCentersQuery, ServiceCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceCentersQuery, ServiceCentersQueryVariables>(ServiceCentersDocument, options);
        }
export type ServiceCentersQueryHookResult = ReturnType<typeof useServiceCentersQuery>;
export type ServiceCentersLazyQueryHookResult = ReturnType<typeof useServiceCentersLazyQuery>;
export type ServiceCentersQueryResult = Apollo.QueryResult<ServiceCentersQuery, ServiceCentersQueryVariables>;
export const InstalledCollectorSettingsDocument = gql`
    query installedCollectorSettings($input: CollectorSettingsInput) {
  collectorSettings(input: $input) {
    items {
      installId
      collectorId
      installedDate
      scope
      settings {
        key
        value
      }
      collectorMetadata {
        id
        name
        installURL
        uninstallURL
        userInstallURL
        userUninstallURL
        type
        image {
          src
        }
      }
      userPreferences {
        key
        value
      }
      canOptOut
    }
    cursor
  }
}
    `;

/**
 * __useInstalledCollectorSettingsQuery__
 *
 * To run a query within a React component, call `useInstalledCollectorSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstalledCollectorSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstalledCollectorSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInstalledCollectorSettingsQuery(baseOptions?: Apollo.QueryHookOptions<InstalledCollectorSettingsQuery, InstalledCollectorSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstalledCollectorSettingsQuery, InstalledCollectorSettingsQueryVariables>(InstalledCollectorSettingsDocument, options);
      }
export function useInstalledCollectorSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstalledCollectorSettingsQuery, InstalledCollectorSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstalledCollectorSettingsQuery, InstalledCollectorSettingsQueryVariables>(InstalledCollectorSettingsDocument, options);
        }
export type InstalledCollectorSettingsQueryHookResult = ReturnType<typeof useInstalledCollectorSettingsQuery>;
export type InstalledCollectorSettingsLazyQueryHookResult = ReturnType<typeof useInstalledCollectorSettingsLazyQuery>;
export type InstalledCollectorSettingsQueryResult = Apollo.QueryResult<InstalledCollectorSettingsQuery, InstalledCollectorSettingsQueryVariables>;
export const LabelSuggestionsDocument = gql`
    query labelSuggestions($input: LabelSuggestionsInput!) {
  labelSuggestions(input: $input) {
    startTime
    endTime
    duration
    inferenceId
    suggestions {
      label {
        id
        type
        name
      }
      suggestedValues {
        idValue
        stringValue
        numericValue
      }
      suggestionMetadata
    }
  }
}
    `;

/**
 * __useLabelSuggestionsQuery__
 *
 * To run a query within a React component, call `useLabelSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLabelSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<LabelSuggestionsQuery, LabelSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelSuggestionsQuery, LabelSuggestionsQueryVariables>(LabelSuggestionsDocument, options);
      }
export function useLabelSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelSuggestionsQuery, LabelSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelSuggestionsQuery, LabelSuggestionsQueryVariables>(LabelSuggestionsDocument, options);
        }
export type LabelSuggestionsQueryHookResult = ReturnType<typeof useLabelSuggestionsQuery>;
export type LabelSuggestionsLazyQueryHookResult = ReturnType<typeof useLabelSuggestionsLazyQuery>;
export type LabelSuggestionsQueryResult = Apollo.QueryResult<LabelSuggestionsQuery, LabelSuggestionsQueryVariables>;
export const LabelsDocument = gql`
    query labels($date: Date!) {
  labels(date: $date) {
    items {
      id
      type
      name
      defaultValue(date: $date) {
        idValue
        stringValue
        numericValue
      }
      origin
    }
  }
}
    `;

/**
 * __useLabelsQuery__
 *
 * To run a query within a React component, call `useLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelsQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useLabelsQuery(baseOptions: Apollo.QueryHookOptions<LabelsQuery, LabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelsQuery, LabelsQueryVariables>(LabelsDocument, options);
      }
export function useLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelsQuery, LabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelsQuery, LabelsQueryVariables>(LabelsDocument, options);
        }
export type LabelsQueryHookResult = ReturnType<typeof useLabelsQuery>;
export type LabelsLazyQueryHookResult = ReturnType<typeof useLabelsLazyQuery>;
export type LabelsQueryResult = Apollo.QueryResult<LabelsQuery, LabelsQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    id
    displayText
    loginName
    slug
    wtsUiEndpoint
    firstName
    lastName
    companyKey
    workWeekStartDay {
      displayText
      uri
    }
    permissions {
      hasViewCollectorsAccess
      hasTimesheetAccess
      hasCompanyCollectorInstallAccess
      hasStartEndEditAccess
      hasSmartSuggestionEditAccess
      hasPsaAccess
    }
    showStartEndFields
    isSmartSuggestionEnabled
    locale {
      dateTimeSettings {
        shortDateFormat {
          luxonPattern
        }
        shortTimeFormat {
          luxonPattern
        }
      }
      language {
        cultureCode
        displayText
        uri
        languageCode
      }
      timeZone {
        displayText
        ianaName
        uri
      }
      customTerms {
        originalTerm
        customTerm
      }
    }
    featureFlags {
      isMenuFeedbackEnabled: boolean(name: "ti-web-menu-feedback", default: false)
      isSmartTimesheetExpandCollapseEnabled: boolean(
        name: "tiw-smart-timesheet-expand-collapse"
        default: false
      )
      isTiWebNotesInsightsPageEnabled: boolean(
        name: "ti-web-notes-insights"
        default: false
      )
      isTiWebTabPersistedCacheQueryEnabled: boolean(
        name: "ti-web-tab-persisted-cache-query"
        default: false
      )
      isTiAutoAcceptUserSettingsEnabled: boolean(
        name: "ti-auto-accept-user-settings-enabled"
        default: false
      )
      isTIWebGroupViewEnabled: boolean(name: "ti-web-group-view", default: false)
      isShowCollapseAll: boolean(name: "ti-web-show-collapse-all", default: false)
      isTiwDurationIndependentStartEndTime: boolean(
        name: "tiw-duration-independent-start-end-time"
        default: false
      )
      isBulkEditPerformanceEnabled: boolean(
        name: "tiw-bulk-edit-performance"
        default: false
      )
      isOfflineImprovementsEnabled: boolean(
        name: "tiw-offline-improvements"
        default: false
      )
      isSmartTimesheetPerformanceEnabled: boolean(
        name: "tiw-smart-timesheet-performance"
        default: false
      )
      isTiwUnifiedCollectorsTab: boolean(
        name: "tiw-unified-collectors-tab"
        default: false
      )
      isMyWorkPerformanceEnabled: boolean(
        name: "ti-mywork-performance-improvements"
        default: false
      )
      isSmartDiaryBetterUxEnabled: boolean(
        name: "tiw-better-ux-smart-diary"
        default: false
      )
      isSessionV2Enabled: boolean(name: "tiw-session-v2", default: false)
      isTiwNewLoginDesign: boolean(name: "tiw-new-login-design", default: false)
      isTiwPauseTimesignalPollEnabled: boolean(
        name: "tiw-pause-timesignal-poll"
        default: false
      )
      isTiwSupervisorInsightsEnabled: boolean(
        name: "tiw-supervisor-insights"
        default: false
      )
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const PeriodsDocument = gql`
    query Periods($input: PeriodsInput) {
  periods(input: $input) {
    items {
      startDate
      endDate
    }
  }
}
    `;

/**
 * __usePeriodsQuery__
 *
 * To run a query within a React component, call `usePeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePeriodsQuery(baseOptions?: Apollo.QueryHookOptions<PeriodsQuery, PeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodsQuery, PeriodsQueryVariables>(PeriodsDocument, options);
      }
export function usePeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodsQuery, PeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodsQuery, PeriodsQueryVariables>(PeriodsDocument, options);
        }
export type PeriodsQueryHookResult = ReturnType<typeof usePeriodsQuery>;
export type PeriodsLazyQueryHookResult = ReturnType<typeof usePeriodsLazyQuery>;
export type PeriodsQueryResult = Apollo.QueryResult<PeriodsQuery, PeriodsQueryVariables>;
export const SelectLabelOptionsDocument = gql`
    query selectLabelOptions($id: String!, $input: SelectOptionsInput) {
  label(id: $id) {
    id
    name
    selectOptions(input: $input) {
      items {
        id
        name
      }
      totalCount
      cursor
    }
  }
}
    `;

/**
 * __useSelectLabelOptionsQuery__
 *
 * To run a query within a React component, call `useSelectLabelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectLabelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectLabelOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectLabelOptionsQuery(baseOptions: Apollo.QueryHookOptions<SelectLabelOptionsQuery, SelectLabelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectLabelOptionsQuery, SelectLabelOptionsQueryVariables>(SelectLabelOptionsDocument, options);
      }
export function useSelectLabelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectLabelOptionsQuery, SelectLabelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectLabelOptionsQuery, SelectLabelOptionsQueryVariables>(SelectLabelOptionsDocument, options);
        }
export type SelectLabelOptionsQueryHookResult = ReturnType<typeof useSelectLabelOptionsQuery>;
export type SelectLabelOptionsLazyQueryHookResult = ReturnType<typeof useSelectLabelOptionsLazyQuery>;
export type SelectLabelOptionsQueryResult = Apollo.QueryResult<SelectLabelOptionsQuery, SelectLabelOptionsQueryVariables>;
export const GetSmartSuggestionSettingsDocument = gql`
    query getSmartSuggestionSettings {
  getSmartSuggestionSettings {
    settings {
      enabled
      accessScopeIn {
        departmentGroups {
          id
          displayText
        }
        employeeTypeGroups {
          id
          displayText
        }
        locations {
          id
          displayText
        }
        divisions {
          id
          displayText
        }
        costCenters {
          id
          displayText
        }
        serviceCenters {
          id
          displayText
        }
      }
    }
  }
}
    `;

/**
 * __useGetSmartSuggestionSettingsQuery__
 *
 * To run a query within a React component, call `useGetSmartSuggestionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmartSuggestionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmartSuggestionSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSmartSuggestionSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSmartSuggestionSettingsQuery, GetSmartSuggestionSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmartSuggestionSettingsQuery, GetSmartSuggestionSettingsQueryVariables>(GetSmartSuggestionSettingsDocument, options);
      }
export function useGetSmartSuggestionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmartSuggestionSettingsQuery, GetSmartSuggestionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmartSuggestionSettingsQuery, GetSmartSuggestionSettingsQueryVariables>(GetSmartSuggestionSettingsDocument, options);
        }
export type GetSmartSuggestionSettingsQueryHookResult = ReturnType<typeof useGetSmartSuggestionSettingsQuery>;
export type GetSmartSuggestionSettingsLazyQueryHookResult = ReturnType<typeof useGetSmartSuggestionSettingsLazyQuery>;
export type GetSmartSuggestionSettingsQueryResult = Apollo.QueryResult<GetSmartSuggestionSettingsQuery, GetSmartSuggestionSettingsQueryVariables>;
export const GetStartEndSettingsDocument = gql`
    query getStartEndSettings {
  getStartEndSettings {
    settings {
      enabled
      accessScopeIn {
        departmentGroups {
          id
          displayText
        }
        employeeTypeGroups {
          id
          displayText
        }
        locations {
          id
          displayText
        }
        divisions {
          id
          displayText
        }
        costCenters {
          id
          displayText
        }
        serviceCenters {
          id
          displayText
        }
      }
    }
  }
}
    `;

/**
 * __useGetStartEndSettingsQuery__
 *
 * To run a query within a React component, call `useGetStartEndSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStartEndSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStartEndSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStartEndSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetStartEndSettingsQuery, GetStartEndSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStartEndSettingsQuery, GetStartEndSettingsQueryVariables>(GetStartEndSettingsDocument, options);
      }
export function useGetStartEndSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStartEndSettingsQuery, GetStartEndSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStartEndSettingsQuery, GetStartEndSettingsQueryVariables>(GetStartEndSettingsDocument, options);
        }
export type GetStartEndSettingsQueryHookResult = ReturnType<typeof useGetStartEndSettingsQuery>;
export type GetStartEndSettingsLazyQueryHookResult = ReturnType<typeof useGetStartEndSettingsLazyQuery>;
export type GetStartEndSettingsQueryResult = Apollo.QueryResult<GetStartEndSettingsQuery, GetStartEndSettingsQueryVariables>;
export const TimeSignalAnalyticsDocument = gql`
    query timeSignalAnalytics($input: TimeSignalAnalyticsInput) {
  timeSignalAnalytics(input: $input) {
    items {
      dimensions {
        dimensionType
        id
        metadata {
          key
          value
        }
        name
      }
      metrics {
        totalCount
        totalDuration
      }
    }
  }
}
    `;

/**
 * __useTimeSignalAnalyticsQuery__
 *
 * To run a query within a React component, call `useTimeSignalAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSignalAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSignalAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeSignalAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<TimeSignalAnalyticsQuery, TimeSignalAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSignalAnalyticsQuery, TimeSignalAnalyticsQueryVariables>(TimeSignalAnalyticsDocument, options);
      }
export function useTimeSignalAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSignalAnalyticsQuery, TimeSignalAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSignalAnalyticsQuery, TimeSignalAnalyticsQueryVariables>(TimeSignalAnalyticsDocument, options);
        }
export type TimeSignalAnalyticsQueryHookResult = ReturnType<typeof useTimeSignalAnalyticsQuery>;
export type TimeSignalAnalyticsLazyQueryHookResult = ReturnType<typeof useTimeSignalAnalyticsLazyQuery>;
export type TimeSignalAnalyticsQueryResult = Apollo.QueryResult<TimeSignalAnalyticsQuery, TimeSignalAnalyticsQueryVariables>;
export const TimeSignalAttributesDocument = gql`
    query timeSignalAttributes($id: String!) {
  timeSignal(id: $id) {
    id
    sources {
      id
      image {
        src
      }
      name
      ref
    }
    attributes {
      name
      sourceId
      sourceRefs
      value
      visible
    }
  }
}
    `;

/**
 * __useTimeSignalAttributesQuery__
 *
 * To run a query within a React component, call `useTimeSignalAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSignalAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSignalAttributesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeSignalAttributesQuery(baseOptions: Apollo.QueryHookOptions<TimeSignalAttributesQuery, TimeSignalAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSignalAttributesQuery, TimeSignalAttributesQueryVariables>(TimeSignalAttributesDocument, options);
      }
export function useTimeSignalAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSignalAttributesQuery, TimeSignalAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSignalAttributesQuery, TimeSignalAttributesQueryVariables>(TimeSignalAttributesDocument, options);
        }
export type TimeSignalAttributesQueryHookResult = ReturnType<typeof useTimeSignalAttributesQuery>;
export type TimeSignalAttributesLazyQueryHookResult = ReturnType<typeof useTimeSignalAttributesLazyQuery>;
export type TimeSignalAttributesQueryResult = Apollo.QueryResult<TimeSignalAttributesQuery, TimeSignalAttributesQueryVariables>;
export const TimeSignalOefAnalyticsDocument = gql`
    query timeSignalOefAnalytics($input: TimeSignalOefAnalyticsInput) {
  timeSignalOefAnalytics(input: $input) {
    items {
      dimensions {
        dimensionType
        id
        metadata {
          key
          value
        }
        name
      }
      metrics {
        totalCount
        totalDuration
      }
    }
  }
}
    `;

/**
 * __useTimeSignalOefAnalyticsQuery__
 *
 * To run a query within a React component, call `useTimeSignalOefAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSignalOefAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSignalOefAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeSignalOefAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<TimeSignalOefAnalyticsQuery, TimeSignalOefAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSignalOefAnalyticsQuery, TimeSignalOefAnalyticsQueryVariables>(TimeSignalOefAnalyticsDocument, options);
      }
export function useTimeSignalOefAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSignalOefAnalyticsQuery, TimeSignalOefAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSignalOefAnalyticsQuery, TimeSignalOefAnalyticsQueryVariables>(TimeSignalOefAnalyticsDocument, options);
        }
export type TimeSignalOefAnalyticsQueryHookResult = ReturnType<typeof useTimeSignalOefAnalyticsQuery>;
export type TimeSignalOefAnalyticsLazyQueryHookResult = ReturnType<typeof useTimeSignalOefAnalyticsLazyQuery>;
export type TimeSignalOefAnalyticsQueryResult = Apollo.QueryResult<TimeSignalOefAnalyticsQuery, TimeSignalOefAnalyticsQueryVariables>;
export const TimeSignalUtilizationAnalyticsDocument = gql`
    query timeSignalUtilizationAnalytics($input: AnalyticsDateRangeFilter) {
  timeSignalUtilizationAnalytics(input: $input) {
    items {
      categoryName
      data {
        date
        totalCount
        totalDuration
      }
    }
  }
}
    `;

/**
 * __useTimeSignalUtilizationAnalyticsQuery__
 *
 * To run a query within a React component, call `useTimeSignalUtilizationAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSignalUtilizationAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSignalUtilizationAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeSignalUtilizationAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<TimeSignalUtilizationAnalyticsQuery, TimeSignalUtilizationAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSignalUtilizationAnalyticsQuery, TimeSignalUtilizationAnalyticsQueryVariables>(TimeSignalUtilizationAnalyticsDocument, options);
      }
export function useTimeSignalUtilizationAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSignalUtilizationAnalyticsQuery, TimeSignalUtilizationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSignalUtilizationAnalyticsQuery, TimeSignalUtilizationAnalyticsQueryVariables>(TimeSignalUtilizationAnalyticsDocument, options);
        }
export type TimeSignalUtilizationAnalyticsQueryHookResult = ReturnType<typeof useTimeSignalUtilizationAnalyticsQuery>;
export type TimeSignalUtilizationAnalyticsLazyQueryHookResult = ReturnType<typeof useTimeSignalUtilizationAnalyticsLazyQuery>;
export type TimeSignalUtilizationAnalyticsQueryResult = Apollo.QueryResult<TimeSignalUtilizationAnalyticsQuery, TimeSignalUtilizationAnalyticsQueryVariables>;
export const TimeSignalsDocument = gql`
    query timeSignals($input: TimeSignalsInput) {
  timeSignals(input: $input) {
    items {
      ...TimeSignalFragment
    }
    totalCount
    cursor
  }
}
    ${TimeSignalFragmentFragmentDoc}`;

/**
 * __useTimeSignalsQuery__
 *
 * To run a query within a React component, call `useTimeSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSignalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeSignalsQuery(baseOptions?: Apollo.QueryHookOptions<TimeSignalsQuery, TimeSignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSignalsQuery, TimeSignalsQueryVariables>(TimeSignalsDocument, options);
      }
export function useTimeSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSignalsQuery, TimeSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSignalsQuery, TimeSignalsQueryVariables>(TimeSignalsDocument, options);
        }
export type TimeSignalsQueryHookResult = ReturnType<typeof useTimeSignalsQuery>;
export type TimeSignalsLazyQueryHookResult = ReturnType<typeof useTimeSignalsLazyQuery>;
export type TimeSignalsQueryResult = Apollo.QueryResult<TimeSignalsQuery, TimeSignalsQueryVariables>;
export const TimeSignalsCountDocument = gql`
    query timeSignalsCount($inputUnClassified: TimeSignalsInput, $inputAccepted: TimeSignalsInput, $inputPrivate: TimeSignalsInput, $inputTrash: TimeSignalsInput) {
  unClassified: timeSignals(input: $inputUnClassified) {
    totalCount
  }
  accepted: timeSignals(input: $inputAccepted) {
    totalCount
  }
  private: timeSignals(input: $inputPrivate) {
    totalCount
  }
  trash: timeSignals(input: $inputTrash) {
    totalCount
  }
}
    `;

/**
 * __useTimeSignalsCountQuery__
 *
 * To run a query within a React component, call `useTimeSignalsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSignalsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSignalsCountQuery({
 *   variables: {
 *      inputUnClassified: // value for 'inputUnClassified'
 *      inputAccepted: // value for 'inputAccepted'
 *      inputPrivate: // value for 'inputPrivate'
 *      inputTrash: // value for 'inputTrash'
 *   },
 * });
 */
export function useTimeSignalsCountQuery(baseOptions?: Apollo.QueryHookOptions<TimeSignalsCountQuery, TimeSignalsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSignalsCountQuery, TimeSignalsCountQueryVariables>(TimeSignalsCountDocument, options);
      }
export function useTimeSignalsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSignalsCountQuery, TimeSignalsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSignalsCountQuery, TimeSignalsCountQueryVariables>(TimeSignalsCountDocument, options);
        }
export type TimeSignalsCountQueryHookResult = ReturnType<typeof useTimeSignalsCountQuery>;
export type TimeSignalsCountLazyQueryHookResult = ReturnType<typeof useTimeSignalsCountLazyQuery>;
export type TimeSignalsCountQueryResult = Apollo.QueryResult<TimeSignalsCountQuery, TimeSignalsCountQueryVariables>;
export const UserCollectorsDocument = gql`
    query userCollectors($input: CollectorInput) {
  collectors(input: $input) {
    items {
      id
      name
      type
      publishedBy
      category
      retryURL
      installURL: userInstallURL
      uninstallURL: userUninstallURL
      image {
        src
      }
    }
  }
}
    `;

/**
 * __useUserCollectorsQuery__
 *
 * To run a query within a React component, call `useUserCollectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCollectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCollectorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCollectorsQuery(baseOptions?: Apollo.QueryHookOptions<UserCollectorsQuery, UserCollectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCollectorsQuery, UserCollectorsQueryVariables>(UserCollectorsDocument, options);
      }
export function useUserCollectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCollectorsQuery, UserCollectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCollectorsQuery, UserCollectorsQueryVariables>(UserCollectorsDocument, options);
        }
export type UserCollectorsQueryHookResult = ReturnType<typeof useUserCollectorsQuery>;
export type UserCollectorsLazyQueryHookResult = ReturnType<typeof useUserCollectorsLazyQuery>;
export type UserCollectorsQueryResult = Apollo.QueryResult<UserCollectorsQuery, UserCollectorsQueryVariables>;
export const WbsClientLabelSearchDocument = gql`
    query wbsClientLabelSearch($date: Date!, $input: WbsLabelValueSearchInput) {
  wbsLabelValueSearch(date: $date) {
    clients(input: $input) {
      items {
        id
        displayText
      }
    }
  }
}
    `;

/**
 * __useWbsClientLabelSearchQuery__
 *
 * To run a query within a React component, call `useWbsClientLabelSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWbsClientLabelSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWbsClientLabelSearchQuery({
 *   variables: {
 *      date: // value for 'date'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWbsClientLabelSearchQuery(baseOptions: Apollo.QueryHookOptions<WbsClientLabelSearchQuery, WbsClientLabelSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WbsClientLabelSearchQuery, WbsClientLabelSearchQueryVariables>(WbsClientLabelSearchDocument, options);
      }
export function useWbsClientLabelSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WbsClientLabelSearchQuery, WbsClientLabelSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WbsClientLabelSearchQuery, WbsClientLabelSearchQueryVariables>(WbsClientLabelSearchDocument, options);
        }
export type WbsClientLabelSearchQueryHookResult = ReturnType<typeof useWbsClientLabelSearchQuery>;
export type WbsClientLabelSearchLazyQueryHookResult = ReturnType<typeof useWbsClientLabelSearchLazyQuery>;
export type WbsClientLabelSearchQueryResult = Apollo.QueryResult<WbsClientLabelSearchQuery, WbsClientLabelSearchQueryVariables>;
export const WbsProgramLabelSearchDocument = gql`
    query wbsProgramLabelSearch($date: Date!, $input: WbsLabelValueSearchInput) {
  wbsLabelValueSearch(date: $date) {
    programs(input: $input) {
      items {
        id
        displayText
      }
    }
  }
}
    `;

/**
 * __useWbsProgramLabelSearchQuery__
 *
 * To run a query within a React component, call `useWbsProgramLabelSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWbsProgramLabelSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWbsProgramLabelSearchQuery({
 *   variables: {
 *      date: // value for 'date'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWbsProgramLabelSearchQuery(baseOptions: Apollo.QueryHookOptions<WbsProgramLabelSearchQuery, WbsProgramLabelSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WbsProgramLabelSearchQuery, WbsProgramLabelSearchQueryVariables>(WbsProgramLabelSearchDocument, options);
      }
export function useWbsProgramLabelSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WbsProgramLabelSearchQuery, WbsProgramLabelSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WbsProgramLabelSearchQuery, WbsProgramLabelSearchQueryVariables>(WbsProgramLabelSearchDocument, options);
        }
export type WbsProgramLabelSearchQueryHookResult = ReturnType<typeof useWbsProgramLabelSearchQuery>;
export type WbsProgramLabelSearchLazyQueryHookResult = ReturnType<typeof useWbsProgramLabelSearchLazyQuery>;
export type WbsProgramLabelSearchQueryResult = Apollo.QueryResult<WbsProgramLabelSearchQuery, WbsProgramLabelSearchQueryVariables>;
export const WbsProjectLabelSearchDocument = gql`
    query wbsProjectLabelSearch($date: Date!, $input: WbsLabelValueSearchInput) {
  wbsLabelValueSearch(date: $date) {
    projects(input: $input) {
      items {
        id
        displayText
      }
    }
  }
}
    `;

/**
 * __useWbsProjectLabelSearchQuery__
 *
 * To run a query within a React component, call `useWbsProjectLabelSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWbsProjectLabelSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWbsProjectLabelSearchQuery({
 *   variables: {
 *      date: // value for 'date'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWbsProjectLabelSearchQuery(baseOptions: Apollo.QueryHookOptions<WbsProjectLabelSearchQuery, WbsProjectLabelSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WbsProjectLabelSearchQuery, WbsProjectLabelSearchQueryVariables>(WbsProjectLabelSearchDocument, options);
      }
export function useWbsProjectLabelSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WbsProjectLabelSearchQuery, WbsProjectLabelSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WbsProjectLabelSearchQuery, WbsProjectLabelSearchQueryVariables>(WbsProjectLabelSearchDocument, options);
        }
export type WbsProjectLabelSearchQueryHookResult = ReturnType<typeof useWbsProjectLabelSearchQuery>;
export type WbsProjectLabelSearchLazyQueryHookResult = ReturnType<typeof useWbsProjectLabelSearchLazyQuery>;
export type WbsProjectLabelSearchQueryResult = Apollo.QueryResult<WbsProjectLabelSearchQuery, WbsProjectLabelSearchQueryVariables>;
export const WbsTaskLabelSearchDocument = gql`
    query wbsTaskLabelSearch($date: Date!, $input: WbsLabelValueSearchInput) {
  wbsLabelValueSearch(date: $date) {
    tasks(input: $input) {
      items {
        id
        displayText
        parents {
          id
          displayText
        }
      }
    }
  }
}
    `;

/**
 * __useWbsTaskLabelSearchQuery__
 *
 * To run a query within a React component, call `useWbsTaskLabelSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWbsTaskLabelSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWbsTaskLabelSearchQuery({
 *   variables: {
 *      date: // value for 'date'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWbsTaskLabelSearchQuery(baseOptions: Apollo.QueryHookOptions<WbsTaskLabelSearchQuery, WbsTaskLabelSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WbsTaskLabelSearchQuery, WbsTaskLabelSearchQueryVariables>(WbsTaskLabelSearchDocument, options);
      }
export function useWbsTaskLabelSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WbsTaskLabelSearchQuery, WbsTaskLabelSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WbsTaskLabelSearchQuery, WbsTaskLabelSearchQueryVariables>(WbsTaskLabelSearchDocument, options);
        }
export type WbsTaskLabelSearchQueryHookResult = ReturnType<typeof useWbsTaskLabelSearchQuery>;
export type WbsTaskLabelSearchLazyQueryHookResult = ReturnType<typeof useWbsTaskLabelSearchLazyQuery>;
export type WbsTaskLabelSearchQueryResult = Apollo.QueryResult<WbsTaskLabelSearchQuery, WbsTaskLabelSearchQueryVariables>;